var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as url from 'url';
export function isResponseEmpty(response) {
    var contentLength = response.headers.get('Content-Length');
    return response.status === 204 || contentLength != null && Number.parseInt(contentLength, 10) === 0;
}
export function isResponseJson(response) {
    var contentType = response.headers.get('Content-Type');
    return contentType != null && contentType.indexOf('json') >= 0;
}
export function parseJson(response) {
    return !isResponseEmpty(response) && isResponseJson(response) ? response.json() : Promise.resolve();
}
export function parseHeaders(response) {
    var headers = {};
    response.headers.forEach(function (value, key) {
        headers[key.toLowerCase()] = value;
    });
    return headers;
}
export function stripQuery(query) {
    if (query === void 0) { query = {}; }
    var initialValue = {};
    return Object.keys(query).reduce(function (previousValue, key) {
        var value = query[key];
        if (value != null)
            previousValue[key] = value;
        return previousValue;
    }, initialValue);
}
var $HttpClient = /** @class */ (function () {
    function $HttpClient(options) {
        this.options = options;
    }
    $HttpClient.prototype.request = function (options) {
        var finalUrl = url.format({
            hostname: 'api.flow.io',
            pathname: options.endpoint,
            protocol: 'https:',
            query: stripQuery(options.query),
        });
        var finalHeaders = __assign({ accept: 'application/json', 'content-type': 'application/json' }, options.headers);
        var request = {
            body: options.body,
            headers: finalHeaders,
            method: options.method,
            url: finalUrl,
        };
        return this.options.fetch(request.url, {
            body: JSON.stringify(request.body),
            headers: request.headers,
            method: request.method,
        }).then(function (response) {
            return parseJson(response).then(function (json) {
                return {
                    body: json,
                    headers: parseHeaders(response),
                    ok: response.ok,
                    request: request,
                    status: response.status,
                    statusText: response.statusText,
                };
            });
        });
    };
    return $HttpClient;
}());
export { $HttpClient };
var $Resource = /** @class */ (function () {
    function $Resource(options) {
        this.client = new $HttpClient(options);
    }
    return $Resource;
}());
export { $Resource };
var AccountPaymentHoldsResource = /** @class */ (function (_super) {
    __extends(AccountPaymentHoldsResource, _super);
    function AccountPaymentHoldsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountPaymentHoldsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/account/payment/holds',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    AccountPaymentHoldsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/account/payment/holds',
            headers: params.headers,
            method: 'POST',
        });
    };
    AccountPaymentHoldsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/account/payment/holds/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    AccountPaymentHoldsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/account/payment/holds/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AccountPaymentHoldsResource;
}($Resource));
export { AccountPaymentHoldsResource };
var AddressConfigurationSettingsResource = /** @class */ (function (_super) {
    __extends(AddressConfigurationSettingsResource, _super);
    function AddressConfigurationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressConfigurationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/address/configuration/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    AddressConfigurationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/address/configuration/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return AddressConfigurationSettingsResource;
}($Resource));
export { AddressConfigurationSettingsResource };
var AftershipWebhooksResource = /** @class */ (function (_super) {
    __extends(AftershipWebhooksResource, _super);
    function AftershipWebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AftershipWebhooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/aftership/webhooks',
            headers: params.headers,
            method: 'POST',
        });
    };
    return AftershipWebhooksResource;
}($Resource));
export { AftershipWebhooksResource };
var AldoItemsResource = /** @class */ (function (_super) {
    __extends(AldoItemsResource, _super);
    function AldoItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AldoItemsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/aldo/items',
            headers: params.headers,
            method: 'POST',
        });
    };
    AldoItemsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/aldo/items/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    AldoItemsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/aldo/items/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    AldoItemsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/aldo/items/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AldoItemsResource;
}($Resource));
export { AldoItemsResource };
var AlertFailureSummariesResource = /** @class */ (function (_super) {
    __extends(AlertFailureSummariesResource, _super);
    function AlertFailureSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the most recent 100 error summaries for a service's failed events*/
    AlertFailureSummariesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/stats/events/failures/summaries',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the most recent 100 error summaries for a service's failed events*/
    AlertFailureSummariesResource.prototype.getByDb = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/summaries/".concat(encodeURIComponent(params.db)),
            headers: params.headers,
            method: 'GET',
            query: {
                queue: params.queue,
            },
        });
    };
    AlertFailureSummariesResource.prototype.deleteByDbAndQueueAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/summaries/".concat(encodeURIComponent(params.db), "/").concat(encodeURIComponent(params.queue), "/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AlertFailureSummariesResource;
}($Resource));
export { AlertFailureSummariesResource };
var AlertRequeueSummariesResource = /** @class */ (function (_super) {
    __extends(AlertRequeueSummariesResource, _super);
    function AlertRequeueSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Requeue failed events for the service*/
    AlertRequeueSummariesResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/".concat(encodeURIComponent(params.db), "/requeue"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return AlertRequeueSummariesResource;
}($Resource));
export { AlertRequeueSummariesResource };
var AllOrganizationsMembershipsResource = /** @class */ (function (_super) {
    __extends(AllOrganizationsMembershipsResource, _super);
    function AllOrganizationsMembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllOrganizationsMembershipsResource.prototype.postAll = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/organizations/membership/all',
            headers: params.headers,
            method: 'POST',
        });
    };
    return AllOrganizationsMembershipsResource;
}($Resource));
export { AllOrganizationsMembershipsResource };
var AuthorizedChargeStatusesResource = /** @class */ (function (_super) {
    __extends(AuthorizedChargeStatusesResource, _super);
    function AuthorizedChargeStatusesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the current status of charges for this order*/
    AuthorizedChargeStatusesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/status/charges"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return AuthorizedChargeStatusesResource;
}($Resource));
export { AuthorizedChargeStatusesResource };
var BankPaymentsResource = /** @class */ (function (_super) {
    __extends(BankPaymentsResource, _super);
    function BankPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankPaymentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/bank/payments',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                billing_statement_id: params.billing_statement_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    BankPaymentsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/bank/payments/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    BankPaymentsResource.prototype.putStatusById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/bank/payments/".concat(encodeURIComponent(params.id), "/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return BankPaymentsResource;
}($Resource));
export { BankPaymentsResource };
var BankPaymentOrdersResource = /** @class */ (function (_super) {
    __extends(BankPaymentOrdersResource, _super);
    function BankPaymentOrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankPaymentOrdersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/bank/payment/orders',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                organization_id: params.organization_id,
                payment_id: params.payment_id,
                sort: params.sort,
            },
        });
    };
    BankPaymentOrdersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/bank/payment/orders/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return BankPaymentOrdersResource;
}($Resource));
export { BankPaymentOrdersResource };
var BankPaymentStatusImportsResource = /** @class */ (function (_super) {
    __extends(BankPaymentStatusImportsResource, _super);
    function BankPaymentStatusImportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankPaymentStatusImportsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/bank/payment/status/imports',
            headers: params.headers,
            method: 'POST',
        });
    };
    BankPaymentStatusImportsResource.prototype.postSent = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/bank/payment/status/imports/sent',
            headers: params.headers,
            method: 'POST',
        });
    };
    BankPaymentStatusImportsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/bank/payment/status/imports/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return BankPaymentStatusImportsResource;
}($Resource));
export { BankPaymentStatusImportsResource };
var BillingOrganizationProcessingRatesResource = /** @class */ (function (_super) {
    __extends(BillingOrganizationProcessingRatesResource, _super);
    function BillingOrganizationProcessingRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingOrganizationProcessingRatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/billing_organization_processing_rates"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    BillingOrganizationProcessingRatesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/billing_organization_processing_rates"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return BillingOrganizationProcessingRatesResource;
}($Resource));
export { BillingOrganizationProcessingRatesResource };
var BillingSandboxSetupsResource = /** @class */ (function (_super) {
    __extends(BillingSandboxSetupsResource, _super);
    function BillingSandboxSetupsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingSandboxSetupsResource.prototype.putBySourceTypeAndSourceId = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/sandbox/setups/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return BillingSandboxSetupsResource;
}($Resource));
export { BillingSandboxSetupsResource };
var BrickWebhookEventsResource = /** @class */ (function (_super) {
    __extends(BrickWebhookEventsResource, _super);
    function BrickWebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrickWebhookEventsResource.prototype.getByFtpFolderId = function (params) {
        return this.client.request({
            endpoint: "/ftp/webhook/events/brickftp/".concat(encodeURIComponent(params.ftp_folder_id)),
            headers: params.headers,
            method: 'GET',
            query: {
                action: params.action,
                at: params.at,
                destination: params.destination,
                interface: params.interface,
                path: params.path,
                type: params.type,
                username: params.username,
            },
        });
    };
    return BrickWebhookEventsResource;
}($Resource));
export { BrickWebhookEventsResource };
var BrowserBundlesResource = /** @class */ (function (_super) {
    __extends(BrowserBundlesResource, _super);
    function BrowserBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*GET accepts a browser_bundle_form serialized to query parameters to enable caching via the CDN.*/
    BrowserBundlesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/bundles/browser"),
            headers: params.headers,
            method: 'GET',
        });
    };
    BrowserBundlesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/bundles/browser"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return BrowserBundlesResource;
}($Resource));
export { BrowserBundlesResource };
var CalculatorOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(CalculatorOrganizationSettingsResource, _super);
    function CalculatorOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalculatorOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/calculator/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    CalculatorOrganizationSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/calculator/settings"),
            headers: params.headers,
            method: 'POST',
        });
    };
    CalculatorOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/calculator/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CalculatorOrganizationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/calculator/settings"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CalculatorOrganizationSettingsResource;
}($Resource));
export { CalculatorOrganizationSettingsResource };
var CallRecordsResource = /** @class */ (function (_super) {
    __extends(CallRecordsResource, _super);
    function CallRecordsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CallRecordsResource.prototype.getByCarrierIdAndReferenceId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/label/call/record/").concat(encodeURIComponent(params.carrier_id), "/").concat(encodeURIComponent(params.reference_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    CallRecordsResource.prototype.getByReferenceId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/label/call/record/").concat(encodeURIComponent(params.reference_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    CallRecordsResource.prototype.getInternalAndPartnerAndCallAndRecordByOrganizationAndReferenceId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/partner/call/record/").concat(encodeURIComponent(params.reference_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CallRecordsResource;
}($Resource));
export { CallRecordsResource };
var CarrierAccountsResource = /** @class */ (function (_super) {
    __extends(CarrierAccountsResource, _super);
    function CarrierAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarrierAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accounts"),
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_id: params.carrier_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CarrierAccountsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accounts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    CarrierAccountsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accounts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    CarrierAccountsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accounts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CarrierAccountsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accounts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    CarrierAccountsResource.prototype.getValidateById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/carrier/accountsvalidate/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CarrierAccountsResource;
}($Resource));
export { CarrierAccountsResource };
var CarrierFilesResource = /** @class */ (function (_super) {
    __extends(CarrierFilesResource, _super);
    function CarrierFilesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarrierFilesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/carrier/files"),
            headers: params.headers,
            method: 'POST',
        });
    };
    CarrierFilesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/carrier/files/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    CarrierFilesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/carrier/files/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CarrierFilesResource;
}($Resource));
export { CarrierFilesResource };
var CatalogSettingsResource = /** @class */ (function (_super) {
    __extends(CatalogSettingsResource, _super);
    function CatalogSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns catalog settings for organization.*/
    CatalogSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/catalog/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Updates the catalog settings of the organization.*/
    CatalogSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/catalog/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CatalogSettingsResource;
}($Resource));
export { CatalogSettingsResource };
var CenterDefaultsResource = /** @class */ (function (_super) {
    __extends(CenterDefaultsResource, _super);
    function CenterDefaultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenterDefaultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/center/defaults"),
            headers: params.headers,
            method: 'GET',
        });
    };
    CenterDefaultsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/center/defaults"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CenterDefaultsResource;
}($Resource));
export { CenterDefaultsResource };
var CenterQueryBuildersResource = /** @class */ (function (_super) {
    __extends(CenterQueryBuildersResource, _super);
    function CenterQueryBuildersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenterQueryBuildersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/center/query/builders"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return CenterQueryBuildersResource;
}($Resource));
export { CenterQueryBuildersResource };
var ChannelAccountsResource = /** @class */ (function (_super) {
    __extends(ChannelAccountsResource, _super);
    function ChannelAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ChannelAccountsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelAccountsResource.prototype.getContactsByKey = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ChannelAccountsResource.prototype.postContactsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ChannelAccountsResource.prototype.getContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelAccountsResource.prototype.deleteContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ChannelAccountsResource.prototype.getStatisticsByKey = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/statistics"),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelAccountsResource.prototype.getTransactionsByKey = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/accounts/").concat(encodeURIComponent(params.key), "/transactions"),
            headers: params.headers,
            method: 'GET',
            query: {
                created_after: params.created_after,
                created_before: params.created_before,
                created_from: params.created_from,
                created_on_or_after: params.created_on_or_after,
                created_on_or_before: params.created_on_or_before,
                created_to: params.created_to,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                posted_after: params.posted_after,
                posted_before: params.posted_before,
                posted_from: params.posted_from,
                posted_on_or_after: params.posted_on_or_after,
                posted_on_or_before: params.posted_on_or_before,
                posted_to: params.posted_to,
                sort: params.sort,
                statement: params.statement,
                status: params.status,
                type: params.type,
            },
        });
    };
    return ChannelAccountsResource;
}($Resource));
export { ChannelAccountsResource };
var ChannelBilledTransactionPairsResource = /** @class */ (function (_super) {
    __extends(ChannelBilledTransactionPairsResource, _super);
    function ChannelBilledTransactionPairsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelBilledTransactionPairsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/channel/billed/transaction/pairs',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                sort: params.sort,
            },
        });
    };
    ChannelBilledTransactionPairsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/channel/billed/transaction/pairs/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelBilledTransactionPairsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/channel/billed/transaction/pairs/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ChannelBilledTransactionPairsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/channel/billed/transaction/pairs/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ChannelBilledTransactionPairsResource;
}($Resource));
export { ChannelBilledTransactionPairsResource };
var ChannelBillingStatementsResource = /** @class */ (function (_super) {
    __extends(ChannelBillingStatementsResource, _super);
    function ChannelBillingStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelBillingStatementsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/account/statements"),
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ChannelBillingStatementsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelBillingStatementsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Generates and sends an email about this statement*/
    ChannelBillingStatementsResource.prototype.postEmailById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/account/statements/").concat(encodeURIComponent(params.id), "/email"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ChannelBillingStatementsResource;
}($Resource));
export { ChannelBillingStatementsResource };
var ChannelCurrencyPairsInternalResource = /** @class */ (function (_super) {
    __extends(ChannelCurrencyPairsInternalResource, _super);
    function ChannelCurrencyPairsInternalResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelCurrencyPairsInternalResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/".concat(encodeURIComponent(params.channel_id), "/currency/pair"),
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                target: params.target,
            },
        });
    };
    return ChannelCurrencyPairsInternalResource;
}($Resource));
export { ChannelCurrencyPairsInternalResource };
var ChannelCurrencySettingsResource = /** @class */ (function (_super) {
    __extends(ChannelCurrencySettingsResource, _super);
    function ChannelCurrencySettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search currency settings. Always paginated.*/
    ChannelCurrencySettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/channel/currency/settings',
            headers: params.headers,
            method: 'GET',
            query: {
                channel: params.channel,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Create currency settings.*/
    ChannelCurrencySettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/channel/currency/settings',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get currency settings.*/
    ChannelCurrencySettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing currency settings.*/
    ChannelCurrencySettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/channel/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ChannelCurrencySettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ChannelCurrencySettingsResource;
}($Resource));
export { ChannelCurrencySettingsResource };
var ChannelDebugTransactionsResource = /** @class */ (function (_super) {
    __extends(ChannelDebugTransactionsResource, _super);
    function ChannelDebugTransactionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelDebugTransactionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/billing/debug/transactions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ChannelDebugTransactionsResource;
}($Resource));
export { ChannelDebugTransactionsResource };
var ChannelFulfillmentsResource = /** @class */ (function (_super) {
    __extends(ChannelFulfillmentsResource, _super);
    function ChannelFulfillmentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Fulfillment information within a channel*/
    ChannelFulfillmentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel), "/fulfillment/search"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    return ChannelFulfillmentsResource;
}($Resource));
export { ChannelFulfillmentsResource };
var ChannelMembershipsResource = /** @class */ (function (_super) {
    __extends(ChannelMembershipsResource, _super);
    function ChannelMembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search memberships. Always paginated.*/
    ChannelMembershipsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/channel/memberships',
            headers: params.headers,
            method: 'GET',
            query: {
                channel: params.channel,
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                role: params.role,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    /*Create a new membership.*/
    ChannelMembershipsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/channel/memberships',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific membership.*/
    ChannelMembershipsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/memberships/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Change the role for a specific membership record.*/
    ChannelMembershipsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/channel/memberships/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ChannelMembershipsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/memberships/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ChannelMembershipsResource;
}($Resource));
export { ChannelMembershipsResource };
var ChannelOrdersResource = /** @class */ (function (_super) {
    __extends(ChannelOrdersResource, _super);
    function ChannelOrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns order information*/
    ChannelOrdersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel), "/orders/search"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                on_or_after: params.on_or_after,
                on_or_before: params.on_or_before,
                organization_id: params.organization_id,
                q: params.q,
                shop_id: params.shop_id,
            },
        });
    };
    return ChannelOrdersResource;
}($Resource));
export { ChannelOrdersResource };
var ChannelOrderAcceptancesResource = /** @class */ (function (_super) {
    __extends(ChannelOrderAcceptancesResource, _super);
    function ChannelOrderAcceptancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves acceptance status of shopify markets orders. Always paginated.*/
    ChannelOrderAcceptancesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/markets/orders/acceptance',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                external_order_reference: params.external_order_reference,
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                organization_id: params.organization_id,
                payment_request_id: params.payment_request_id,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Enable reviewers to update the channel order acceptance status.*/
    ChannelOrderAcceptancesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/shopify/markets/orders/acceptance/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ChannelOrderAcceptancesResource;
}($Resource));
export { ChannelOrderAcceptancesResource };
var ChannelOrderAcceptanceDetailsResource = /** @class */ (function (_super) {
    __extends(ChannelOrderAcceptanceDetailsResource, _super);
    function ChannelOrderAcceptanceDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves acceptance and a shopify markets orders. Always paginated.*/
    ChannelOrderAcceptanceDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/markets/orders/acceptance/details',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                external_order_reference: params.external_order_reference,
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                organization_id: params.organization_id,
                payment_request_id: params.payment_request_id,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return ChannelOrderAcceptanceDetailsResource;
}($Resource));
export { ChannelOrderAcceptanceDetailsResource };
var ChannelOrganizationShopifyResource = /** @class */ (function (_super) {
    __extends(ChannelOrganizationShopifyResource, _super);
    function ChannelOrganizationShopifyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelOrganizationShopifyResource.prototype.postShopifyAndInstall = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/organizations/shopify/install"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ChannelOrganizationShopifyResource.prototype.putShopifyAndInstallByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/organizations/shopify/install/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ChannelOrganizationShopifyResource;
}($Resource));
export { ChannelOrganizationShopifyResource };
var ChargebacksResource = /** @class */ (function (_super) {
    __extends(ChargebacksResource, _super);
    function ChargebacksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChargebacksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/chargebacks"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                payment_status: params.payment_status,
                sort: params.sort,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    ChargebacksResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/chargebacks/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                chargeback_key: params.chargeback_key,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific chargeback.*/
    ChargebacksResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/chargebacks/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ChargebacksResource;
}($Resource));
export { ChargebacksResource };
var CheckoutBundlesResource = /** @class */ (function (_super) {
    __extends(CheckoutBundlesResource, _super);
    function CheckoutBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Converts a cart into an order and returns all associated content needed to render checkout in a single bundle.*/
    CheckoutBundlesResource.prototype.postCartById = function (params) {
        return this.client.request({
            endpoint: "/bundles/checkout/cart/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'POST',
            query: {
                feature_q: params.feature_q,
            },
        });
    };
    /*Returns all associated content needed to render checkout.*/
    CheckoutBundlesResource.prototype.getOrderByOrgAndNumber = function (params) {
        return this.client.request({
            endpoint: "/bundles/checkout/".concat(encodeURIComponent(params.org), "/order/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
            query: {
                feature_q: params.feature_q,
            },
        });
    };
    /*This method will either lookup or create a new order if possible based on the provided order number. The intent is to handle a 401 when the session id does not match - and enable returning a new order tied to the session with the same data (absent PII).*/
    CheckoutBundlesResource.prototype.postOrdersByOrg = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/bundles/checkout/".concat(encodeURIComponent(params.org), "/orders"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return CheckoutBundlesResource;
}($Resource));
export { CheckoutBundlesResource };
var CheckoutConfigurationsResource = /** @class */ (function (_super) {
    __extends(CheckoutConfigurationsResource, _super);
    function CheckoutConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search checkout configurations. Always paginated.*/
    CheckoutConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/configurations"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new checkout configuration*/
    CheckoutConfigurationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/configurations"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific checkout configuration.*/
    CheckoutConfigurationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/configurations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing checkout configuration*/
    CheckoutConfigurationsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/configurations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Removes an existing checkout configuration*/
    CheckoutConfigurationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/configurations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CheckoutConfigurationsResource;
}($Resource));
export { CheckoutConfigurationsResource };
var CheckoutContentSummariesResource = /** @class */ (function (_super) {
    __extends(CheckoutContentSummariesResource, _super);
    function CheckoutContentSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutContentSummariesResource.prototype.getCheckout = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/content/checkout"),
            headers: params.headers,
            method: 'GET',
            query: {
                locale: params.locale,
            },
        });
    };
    /*Endpoint used to access data for the 'load' content type - This allows us to rewrite URLs to serve from api proxy, avoiding any issues with CORS*/
    CheckoutContentSummariesResource.prototype.getUrlByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/content/").concat(encodeURIComponent(params.key), "/url"),
            headers: params.headers,
            method: 'GET',
            query: {
                url: params.url,
            },
        });
    };
    return CheckoutContentSummariesResource;
}($Resource));
export { CheckoutContentSummariesResource };
var CheckoutFinalizeOrderFormsResource = /** @class */ (function (_super) {
    __extends(CheckoutFinalizeOrderFormsResource, _super);
    function CheckoutFinalizeOrderFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutFinalizeOrderFormsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/checkout/bundles/orders/").concat(encodeURIComponent(params.number), "/finalize"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CheckoutFinalizeOrderFormsResource;
}($Resource));
export { CheckoutFinalizeOrderFormsResource };
var CheckoutSubmitOrderBundlesResource = /** @class */ (function (_super) {
    __extends(CheckoutSubmitOrderBundlesResource, _super);
    function CheckoutSubmitOrderBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutSubmitOrderBundlesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/checkout/bundles/orders/").concat(encodeURIComponent(params.number), "/submit"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CheckoutSubmitOrderBundlesResource;
}($Resource));
export { CheckoutSubmitOrderBundlesResource };
var CiphersResource = /** @class */ (function (_super) {
    __extends(CiphersResource, _super);
    function CiphersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Encrypts a value and returns a reference to it.*/
    CiphersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/cipher',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Encrypts values in batch and returns a sequence of reference to them.*/
    CiphersResource.prototype.postBatch = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/cipher/batch',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get the plaintext value of a cipher.*/
    CiphersResource.prototype.postGet = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/cipher/get',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Gets the plaintext values of ciphers in batch.*/
    CiphersResource.prototype.postGetAndBatch = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/cipher/get/batch',
            headers: params.headers,
            method: 'POST',
        });
    };
    return CiphersResource;
}($Resource));
export { CiphersResource };
var ClassificationsResource = /** @class */ (function (_super) {
    __extends(ClassificationsResource, _super);
    function ClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/classifications"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Products that are classified either manually or automatically by the machine learning model with high confidence score*/
    ClassificationsResource.prototype.getClassified = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/classifications/classified"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                product_id: params.product_id,
                q: params.q,
            },
        });
    };
    /*Products that are in unclassified products queue, requiring either manual classifications or verifications*/
    ClassificationsResource.prototype.getOutstanding = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/classifications/outstanding"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                product_id: params.product_id,
                q: params.q,
                status: params.status,
            },
        });
    };
    return ClassificationsResource;
}($Resource));
export { ClassificationsResource };
var ClassificationActionsResource = /** @class */ (function (_super) {
    __extends(ClassificationActionsResource, _super);
    function ClassificationActionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationActionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/classification/actions',
            headers: params.headers,
            method: 'GET',
            query: {
                sort: params.sort,
                updated_by_user_id: params.updated_by_user_id,
            },
        });
    };
    ClassificationActionsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/classification/actions',
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ClassificationActionsResource;
}($Resource));
export { ClassificationActionsResource };
var ClassificationDetailsResource = /** @class */ (function (_super) {
    __extends(ClassificationDetailsResource, _super);
    function ClassificationDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/classification/details',
            headers: params.headers,
            method: 'GET',
            query: {
                date_from: params.date_from,
                date_to: params.date_to,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                product_id: params.product_id,
                updated_by_user_id: params.updated_by_user_id,
            },
        });
    };
    return ClassificationDetailsResource;
}($Resource));
export { ClassificationDetailsResource };
var ClassificationProductSummaryPagesResource = /** @class */ (function (_super) {
    __extends(ClassificationProductSummaryPagesResource, _super);
    function ClassificationProductSummaryPagesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationProductSummaryPagesResource.prototype.getOrganizations = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/organizations',
            headers: params.headers,
            method: 'GET',
        });
    };
    ClassificationProductSummaryPagesResource.prototype.getProducts = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/products',
            headers: params.headers,
            method: 'GET',
            query: {
                cursor: params.cursor,
                organization: params.organization,
                status: params.status,
            },
        });
    };
    return ClassificationProductSummaryPagesResource;
}($Resource));
export { ClassificationProductSummaryPagesResource };
var ClassificationRequeueRequestsResource = /** @class */ (function (_super) {
    __extends(ClassificationRequeueRequestsResource, _super);
    function ClassificationRequeueRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationRequeueRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/classification/requeue/request"),
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
            },
        });
    };
    return ClassificationRequeueRequestsResource;
}($Resource));
export { ClassificationRequeueRequestsResource };
var ClassificationStatisticsResource = /** @class */ (function (_super) {
    __extends(ClassificationStatisticsResource, _super);
    function ClassificationStatisticsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get statistics for items by harmonization status*/
    ClassificationStatisticsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/classification/statistics"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ClassificationStatisticsResource;
}($Resource));
export { ClassificationStatisticsResource };
var ClassificationTaxonomyResource = /** @class */ (function (_super) {
    __extends(ClassificationTaxonomyResource, _super);
    function ClassificationTaxonomyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationTaxonomyResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/taxonomy',
            headers: params.headers,
            method: 'GET',
        });
    };
    return ClassificationTaxonomyResource;
}($Resource));
export { ClassificationTaxonomyResource };
var CliLogEntriesResource = /** @class */ (function (_super) {
    __extends(CliLogEntriesResource, _super);
    function CliLogEntriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CliLogEntriesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/cli/log/entries',
            headers: params.headers,
            method: 'POST',
        });
    };
    return CliLogEntriesResource;
}($Resource));
export { CliLogEntriesResource };
var CommercialInvoiceComparisonsResource = /** @class */ (function (_super) {
    __extends(CommercialInvoiceComparisonsResource, _super);
    function CommercialInvoiceComparisonsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommercialInvoiceComparisonsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/commercial_invoices/comparison"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return CommercialInvoiceComparisonsResource;
}($Resource));
export { CommercialInvoiceComparisonsResource };
var CommercialInvoiceSummariesResource = /** @class */ (function (_super) {
    __extends(CommercialInvoiceSummariesResource, _super);
    function CommercialInvoiceSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommercialInvoiceSummariesResource.prototype.getLabelByLabelId = function (params) {
        return this.client.request({
            endpoint: "/internal/commercial/invoice/summaries/label/".concat(encodeURIComponent(params.label_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CommercialInvoiceSummariesResource;
}($Resource));
export { CommercialInvoiceSummariesResource };
var CompliancesResource = /** @class */ (function (_super) {
    __extends(CompliancesResource, _super);
    function CompliancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompliancesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/compliance"),
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    CompliancesResource.prototype.getTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/compliance/type/").concat(encodeURIComponent(params.type), "/destination/").concat(encodeURIComponent(params.destination)),
            headers: params.headers,
            method: 'GET',
        });
    };
    CompliancesResource.prototype.putTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/compliance/type/").concat(encodeURIComponent(params.type), "/destination/").concat(encodeURIComponent(params.destination)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CompliancesResource.prototype.deleteTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/compliance/type/").concat(encodeURIComponent(params.type), "/destination/").concat(encodeURIComponent(params.destination)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CompliancesResource;
}($Resource));
export { CompliancesResource };
var ConsumerOptinActivitiesResource = /** @class */ (function (_super) {
    __extends(ConsumerOptinActivitiesResource, _super);
    function ConsumerOptinActivitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumerOptinActivitiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/activities"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ConsumerOptinActivitiesResource;
}($Resource));
export { ConsumerOptinActivitiesResource };
var ContentSchemasResource = /** @class */ (function (_super) {
    __extends(ContentSchemasResource, _super);
    function ContentSchemasResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentSchemasResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/content/schemas',
            headers: params.headers,
            method: 'GET',
            query: {
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ContentSchemasResource.prototype.getBySchemaKey = function (params) {
        return this.client.request({
            endpoint: "/content/schemas/".concat(encodeURIComponent(params.schema_key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ContentSchemasResource;
}($Resource));
export { ContentSchemasResource };
var CourthouseProductSummariesResource = /** @class */ (function (_super) {
    __extends(CourthouseProductSummariesResource, _super);
    function CourthouseProductSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns products that are classified either manually or automatically by the machine learning model or products that are in unclassified.*/
    CourthouseProductSummariesResource.prototype.getSearchAndItemsByItemNumber = function (params) {
        return this.client.request({
            endpoint: "/courthouse/products/search/items/".concat(encodeURIComponent(params.item_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CourthouseProductSummariesResource;
}($Resource));
export { CourthouseProductSummariesResource };
var CustomerSecretsResource = /** @class */ (function (_super) {
    __extends(CustomerSecretsResource, _super);
    function CustomerSecretsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSecretsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/customers/secret"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CustomerSecretsResource;
}($Resource));
export { CustomerSecretsResource };
var CustomsDetailsResource = /** @class */ (function (_super) {
    __extends(CustomsDetailsResource, _super);
    function CustomsDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the customs details for the specified destination and item numbers.*/
    CustomsDetailsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/customs/details"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return CustomsDetailsResource;
}($Resource));
export { CustomsDetailsResource };
var DebugOrdersResource = /** @class */ (function (_super) {
    __extends(DebugOrdersResource, _super);
    function DebugOrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DebugOrdersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/debug/order',
            headers: params.headers,
            method: 'POST',
        });
    };
    return DebugOrdersResource;
}($Resource));
export { DebugOrdersResource };
var DebugOrderTransactionsResource = /** @class */ (function (_super) {
    __extends(DebugOrderTransactionsResource, _super);
    function DebugOrderTransactionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DebugOrderTransactionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/debug/order/transactions',
            headers: params.headers,
            method: 'POST',
        });
    };
    return DebugOrderTransactionsResource;
}($Resource));
export { DebugOrderTransactionsResource };
var DeliveredDutyOptionsResource = /** @class */ (function (_super) {
    __extends(DeliveredDutyOptionsResource, _super);
    function DeliveredDutyOptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns available options for shipping duty display preferences.*/
    DeliveredDutyOptionsResource.prototype.getOptionsAndV2 = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.key), "/preference/display/shipping/duty/options/v2"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return DeliveredDutyOptionsResource;
}($Resource));
export { DeliveredDutyOptionsResource };
var DeliveredDutyPreferencesResource = /** @class */ (function (_super) {
    __extends(DeliveredDutyPreferencesResource, _super);
    function DeliveredDutyPreferencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliveredDutyPreferencesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.key), "/preference/display/shipping/duty"),
            headers: params.headers,
            method: 'GET',
        });
    };
    DeliveredDutyPreferencesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.key), "/preference/display/shipping/duty"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return DeliveredDutyPreferencesResource;
}($Resource));
export { DeliveredDutyPreferencesResource };
var DiscountCodesResource = /** @class */ (function (_super) {
    __extends(DiscountCodesResource, _super);
    function DiscountCodesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Applies the discount code on the order, if valid*/
    DiscountCodesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/discount/codes"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Removes the discount code from the order*/
    DiscountCodesResource.prototype.deleteByCode = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/discount/codes/").concat(encodeURIComponent(params.code)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return DiscountCodesResource;
}($Resource));
export { DiscountCodesResource };
var DisputesResource = /** @class */ (function (_super) {
    __extends(DisputesResource, _super);
    function DisputesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisputesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/disputes',
            headers: params.headers,
            method: 'GET',
            query: {
                created_after: params.created_after,
                created_before: params.created_before,
                defense_outcomes: params.defense_outcomes,
                expires_after: params.expires_after,
                expires_before: params.expires_before,
                id: params.id,
                issued_after: params.issued_after,
                issued_before: params.issued_before,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                payment_methods: params.payment_methods,
                processors: params.processors,
                reporting_categories: params.reporting_categories,
                sort: params.sort,
                statuses: params.statuses,
            },
        });
    };
    DisputesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/disputes/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    DisputesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/disputes/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return DisputesResource;
}($Resource));
export { DisputesResource };
var DutyInternalRatesResource = /** @class */ (function (_super) {
    __extends(DutyInternalRatesResource, _super);
    function DutyInternalRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DutyInternalRatesResource.prototype.getDestinationAndOriginByDestinationAndOrigin = function (params) {
        return this.client.request({
            endpoint: "/harmonization/rates/destination/".concat(encodeURIComponent(params.destination), "/origin/").concat(encodeURIComponent(params.origin)),
            headers: params.headers,
            method: 'GET',
            query: {
                hs6: params.hs6,
                id: params.id,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
            },
        });
    };
    return DutyInternalRatesResource;
}($Resource));
export { DutyInternalRatesResource };
var ErpFlowFilesResource = /** @class */ (function (_super) {
    __extends(ErpFlowFilesResource, _super);
    function ErpFlowFilesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErpFlowFilesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/flow/files"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    ErpFlowFilesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/flow/files"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ErpFlowFilesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/flow/files/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ErpFlowFilesResource;
}($Resource));
export { ErpFlowFilesResource };
var ErpFlowVendorsResource = /** @class */ (function (_super) {
    __extends(ErpFlowVendorsResource, _super);
    function ErpFlowVendorsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErpFlowVendorsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/flow/vendors"),
            headers: params.headers,
            method: 'GET',
            query: {
                company_id: params.company_id,
                different: params.different,
                entity_id: params.entity_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    ErpFlowVendorsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/flow/vendors/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ErpFlowVendorsResource;
}($Resource));
export { ErpFlowVendorsResource };
var ErpPriorityFilesResource = /** @class */ (function (_super) {
    __extends(ErpPriorityFilesResource, _super);
    function ErpPriorityFilesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErpPriorityFilesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/files"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    ErpPriorityFilesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/files"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ErpPriorityFilesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/files/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ErpPriorityFilesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/files/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ErpPriorityFilesResource;
}($Resource));
export { ErpPriorityFilesResource };
var ErpPriorityVendorsResource = /** @class */ (function (_super) {
    __extends(ErpPriorityVendorsResource, _super);
    function ErpPriorityVendorsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErpPriorityVendorsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/vendors"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ErpPriorityVendorsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/vendors/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ErpPriorityVendorsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/priority/vendors/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ErpPriorityVendorsResource;
}($Resource));
export { ErpPriorityVendorsResource };
var ErpVendorStatusesResource = /** @class */ (function (_super) {
    __extends(ErpVendorStatusesResource, _super);
    function ErpVendorStatusesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErpVendorStatusesResource.prototype.getStatus = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/erp/vendors/status"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ErpVendorStatusesResource;
}($Resource));
export { ErpVendorStatusesResource };
var ExplicitStatementsResource = /** @class */ (function (_super) {
    __extends(ExplicitStatementsResource, _super);
    function ExplicitStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExplicitStatementsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/explicit/statements',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ExplicitStatementsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/explicit/statements',
            headers: params.headers,
            method: 'POST',
        });
    };
    ExplicitStatementsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/explicit/statements/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Deletes the explicit statement record but not the underlying statement created.*/
    ExplicitStatementsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/explicit/statements/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ExplicitStatementsResource;
}($Resource));
export { ExplicitStatementsResource };
var ExternalFulfillmentProofsResource = /** @class */ (function (_super) {
    __extends(ExternalFulfillmentProofsResource, _super);
    function ExternalFulfillmentProofsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExternalFulfillmentProofsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/external/fulfillment/proof',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    ExternalFulfillmentProofsResource.prototype.getOrganizationAndOrderNumberByOrganizationIdAndOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/external/fulfillment/proof/organization/".concat(encodeURIComponent(params.organization_id), "/order_number/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ExternalFulfillmentProofsResource.prototype.putOrganizationAndOrderNumberByOrganizationIdAndOrderNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/external/fulfillment/proof/organization/".concat(encodeURIComponent(params.organization_id), "/order_number/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ExternalFulfillmentProofsResource.prototype.deleteOrganizationAndOrderNumberByOrganizationIdAndOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/external/fulfillment/proof/organization/".concat(encodeURIComponent(params.organization_id), "/order_number/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ExternalFulfillmentProofsResource;
}($Resource));
export { ExternalFulfillmentProofsResource };
var FeaturesResource = /** @class */ (function (_super) {
    __extends(FeaturesResource, _super);
    function FeaturesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                q: params.q,
                scope: params.scope,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    FeaturesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Builds a query to search features*/
    FeaturesResource.prototype.postQueryAndBuilders = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/query/builders"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Builds a query related to a specific rule*/
    FeaturesResource.prototype.postRuleAndQueryAndBuilders = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/rule/query/builders"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific user.*/
    FeaturesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FeaturesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FeaturesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FeaturesResource.prototype.putReleaseByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key), "/release"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Adds a rule to this feature. Position of rule will be last*/
    FeaturesResource.prototype.postRulesByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key), "/rules"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Updates a rule*/
    FeaturesResource.prototype.putRulesByKeyAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key), "/rules/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes the rule with the specified ID*/
    FeaturesResource.prototype.deleteRulesByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key), "/rules/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FeaturesResource.prototype.putStatusByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/features/").concat(encodeURIComponent(params.key), "/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FeaturesResource;
}($Resource));
export { FeaturesResource };
var FeatureValuesResource = /** @class */ (function (_super) {
    __extends(FeatureValuesResource, _super);
    function FeatureValuesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureValuesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/feature/values"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return FeatureValuesResource;
}($Resource));
export { FeatureValuesResource };
var FinanceBankAccountsResource = /** @class */ (function (_super) {
    __extends(FinanceBankAccountsResource, _super);
    function FinanceBankAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FinanceBankAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/finance/bank/accounts',
            headers: params.headers,
            method: 'GET',
            query: {
                environment: params.environment,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                source_id: params.source_id,
                source_type: params.source_type,
            },
        });
    };
    return FinanceBankAccountsResource;
}($Resource));
export { FinanceBankAccountsResource };
var FinanceBankPaymentsResource = /** @class */ (function (_super) {
    __extends(FinanceBankPaymentsResource, _super);
    function FinanceBankPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FinanceBankPaymentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/finance/bank/payments',
            headers: params.headers,
            method: 'GET',
            query: {
                environment: params.environment,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                source_id: params.source_id,
                source_type: params.source_type,
                status: params.status,
            },
        });
    };
    return FinanceBankPaymentsResource;
}($Resource));
export { FinanceBankPaymentsResource };
var FinancialMerchantCategoriesResource = /** @class */ (function (_super) {
    __extends(FinancialMerchantCategoriesResource, _super);
    function FinancialMerchantCategoriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FinancialMerchantCategoriesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/flow/financial/merchant/categories',
            headers: params.headers,
            method: 'GET',
        });
    };
    return FinancialMerchantCategoriesResource;
}($Resource));
export { FinancialMerchantCategoriesResource };
var FinancialReportingStatementsResource = /** @class */ (function (_super) {
    __extends(FinancialReportingStatementsResource, _super);
    function FinancialReportingStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FinancialReportingStatementsResource.prototype.getByStatementNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/financial_reporting_statement/".concat(encodeURIComponent(params.statement_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FinancialReportingStatementsResource.prototype.postByStatementNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/financial_reporting_statement/".concat(encodeURIComponent(params.statement_number)),
            headers: params.headers,
            method: 'POST',
        });
    };
    return FinancialReportingStatementsResource;
}($Resource));
export { FinancialReportingStatementsResource };
var FlexeWebhooksResource = /** @class */ (function (_super) {
    __extends(FlexeWebhooksResource, _super);
    function FlexeWebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlexeWebhooksResource.prototype.postReceipt = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/flexe/webhook/receipt',
            headers: params.headers,
            method: 'POST',
        });
    };
    FlexeWebhooksResource.prototype.postShipment = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/flexe/webhook/shipment',
            headers: params.headers,
            method: 'POST',
        });
    };
    return FlexeWebhooksResource;
}($Resource));
export { FlexeWebhooksResource };
var FlowAccountsResource = /** @class */ (function (_super) {
    __extends(FlowAccountsResource, _super);
    function FlowAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FlowAccountsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowAccountsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FlowAccountsResource.prototype.getContactsByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FlowAccountsResource.prototype.postContactsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    FlowAccountsResource.prototype.getContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowAccountsResource.prototype.deleteContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FlowAccountsResource.prototype.getStatisticsByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/statistics"),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowAccountsResource.prototype.getTransactionsByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/transactions"),
            headers: params.headers,
            method: 'GET',
            query: {
                created_after: params.created_after,
                created_before: params.created_before,
                created_from: params.created_from,
                created_on_or_after: params.created_on_or_after,
                created_on_or_before: params.created_on_or_before,
                created_to: params.created_to,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                posted_after: params.posted_after,
                posted_before: params.posted_before,
                posted_from: params.posted_from,
                posted_on_or_after: params.posted_on_or_after,
                posted_on_or_before: params.posted_on_or_before,
                posted_to: params.posted_to,
                sort: params.sort,
                statement: params.statement,
                status: params.status,
                type: params.type,
            },
        });
    };
    /*Creates a manual transaction for this account*/
    FlowAccountsResource.prototype.postTransactionsAndManualByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/transactions/manual"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Deletes a manual transaction for this account, if not associated with a billing statement.*/
    FlowAccountsResource.prototype.deleteTransactionsAndManualByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/accounts/").concat(encodeURIComponent(params.key), "/transactions/manual/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FlowAccountsResource;
}($Resource));
export { FlowAccountsResource };
var FlowBillingStatementsResource = /** @class */ (function (_super) {
    __extends(FlowBillingStatementsResource, _super);
    function FlowBillingStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowBillingStatementsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/account/statements"),
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FlowBillingStatementsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowBillingStatementsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Generates and sends an email about this statement*/
    FlowBillingStatementsResource.prototype.postEmailById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/".concat(encodeURIComponent(params.source_type), "/").concat(encodeURIComponent(params.source_id), "/account/statements/").concat(encodeURIComponent(params.id), "/email"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return FlowBillingStatementsResource;
}($Resource));
export { FlowBillingStatementsResource };
var FlowChannelOrganizationsResource = /** @class */ (function (_super) {
    __extends(FlowChannelOrganizationsResource, _super);
    function FlowChannelOrganizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowChannelOrganizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/channel/organizations',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                sort: params.sort,
            },
        });
    };
    return FlowChannelOrganizationsResource;
}($Resource));
export { FlowChannelOrganizationsResource };
var FlowLabProjectsResource = /** @class */ (function (_super) {
    __extends(FlowLabProjectsResource, _super);
    function FlowLabProjectsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowLabProjectsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/lab/projects',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FlowLabProjectsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/lab/projects',
            headers: params.headers,
            method: 'POST',
        });
    };
    FlowLabProjectsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/lab/projects/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowLabProjectsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/lab/projects/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FlowLabProjectsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/lab/projects/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FlowLabProjectsResource;
}($Resource));
export { FlowLabProjectsResource };
var FlowLabelSettingsResource = /** @class */ (function (_super) {
    __extends(FlowLabelSettingsResource, _super);
    function FlowLabelSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowLabelSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/label/settings',
            headers: params.headers,
            method: 'POST',
        });
    };
    FlowLabelSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/label/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowLabelSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/label/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FlowLabelSettingsResource;
}($Resource));
export { FlowLabelSettingsResource };
var FraudPendingReviewsResource = /** @class */ (function (_super) {
    __extends(FraudPendingReviewsResource, _super);
    function FraudPendingReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FraudPendingReviewsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/fraud/manual/pending',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                provider: params.provider,
                sort: params.sort,
            },
        });
    };
    return FraudPendingReviewsResource;
}($Resource));
export { FraudPendingReviewsResource };
var FraudPendingReviewDetailsResource = /** @class */ (function (_super) {
    __extends(FraudPendingReviewDetailsResource, _super);
    function FraudPendingReviewDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Updates apply_at attribute of a pending fraud review*/
    FraudPendingReviewDetailsResource.prototype.putApplyAndAtByFraudReviewId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/fraud/pending/").concat(encodeURIComponent(params.fraud_review_id), "/apply/at"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FraudPendingReviewDetailsResource;
}($Resource));
export { FraudPendingReviewDetailsResource };
var FraudProviderConfigurationsResource = /** @class */ (function (_super) {
    __extends(FraudProviderConfigurationsResource, _super);
    function FraudProviderConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve configurations for the default fraud provider for an organization. In the future, this will be replaced by /providers/:key when we support multiple providers per organization.*/
    FraudProviderConfigurationsResource.prototype.getDefault = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/providers/default"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update the configuration for the default fraud provider for an organization. In the future, this will be replaced by /providers/:key when we support multiple providers per organization.*/
    FraudProviderConfigurationsResource.prototype.putDefault = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/providers/default"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the configuration for the default fraud provider for an organization. In the future, this will be replaced by /providers/:key when we support multiple providers per organization.*/
    FraudProviderConfigurationsResource.prototype.deleteDefault = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/providers/default"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FraudProviderConfigurationsResource;
}($Resource));
export { FraudProviderConfigurationsResource };
var FraudReviewsResource = /** @class */ (function (_super) {
    __extends(FraudReviewsResource, _super);
    function FraudReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search fraud review. Always paginated.*/
    FraudReviewsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/reviews"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                payment_request_id: params.payment_request_id,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    FraudReviewsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/reviews/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                fraud_review_id: params.fraud_review_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                payment_request_id: params.payment_request_id,
                sort: params.sort,
            },
        });
    };
    FraudReviewsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/reviews/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return FraudReviewsResource;
}($Resource));
export { FraudReviewsResource };
var FraudReviewDecisionsResource = /** @class */ (function (_super) {
    __extends(FraudReviewDecisionsResource, _super);
    function FraudReviewDecisionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Make decision on a fraud check pending review*/
    FraudReviewDecisionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/reviews/").concat(encodeURIComponent(params.id), "/decision"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return FraudReviewDecisionsResource;
}($Resource));
export { FraudReviewDecisionsResource };
var FtpSettingsResource = /** @class */ (function (_super) {
    __extends(FtpSettingsResource, _super);
    function FtpSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FtpSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/demandware/ftp-settings"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FtpSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/demandware/ftp-settings"),
            headers: params.headers,
            method: 'POST',
        });
    };
    FtpSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/demandware/ftp-settings/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    FtpSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/demandware/ftp-settings/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FtpSettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization_id), "/demandware/ftp-settings/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FtpSettingsResource;
}($Resource));
export { FtpSettingsResource };
var GenerateLoadsResource = /** @class */ (function (_super) {
    __extends(GenerateLoadsResource, _super);
    function GenerateLoadsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenerateLoadsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/generate_load',
            headers: params.headers,
            method: 'POST',
        });
    };
    return GenerateLoadsResource;
}($Resource));
export { GenerateLoadsResource };
var GiftCardProgramsResource = /** @class */ (function (_super) {
    __extends(GiftCardProgramsResource, _super);
    function GiftCardProgramsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GiftCardProgramsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift_cards"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Adds a potential gift card. Will be rejected if this organization is not set up to manage gift cards or if the value of the gift card cannot be determined.*/
    GiftCardProgramsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift_cards"),
            headers: params.headers,
            method: 'POST',
        });
    };
    GiftCardProgramsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift_cards/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return GiftCardProgramsResource;
}($Resource));
export { GiftCardProgramsResource };
var GlobalSearchResultsResource = /** @class */ (function (_super) {
    __extends(GlobalSearchResultsResource, _super);
    function GlobalSearchResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalSearchResultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/search/global"),
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return GlobalSearchResultsResource;
}($Resource));
export { GlobalSearchResultsResource };
var GoogleShoppingSettingsResource = /** @class */ (function (_super) {
    __extends(GoogleShoppingSettingsResource, _super);
    function GoogleShoppingSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleShoppingSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/settings/google"),
            headers: params.headers,
            method: 'GET',
        });
    };
    GoogleShoppingSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/settings/google"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return GoogleShoppingSettingsResource;
}($Resource));
export { GoogleShoppingSettingsResource };
var HarmonizationItemClassificationsResource = /** @class */ (function (_super) {
    __extends(HarmonizationItemClassificationsResource, _super);
    function HarmonizationItemClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HarmonizationItemClassificationsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/harmonization/item/classifications/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                item_number: params.item_number,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return HarmonizationItemClassificationsResource;
}($Resource));
export { HarmonizationItemClassificationsResource };
var HarmonizationThresholdsResource = /** @class */ (function (_super) {
    __extends(HarmonizationThresholdsResource, _super);
    function HarmonizationThresholdsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns list of thresholds*/
    HarmonizationThresholdsResource.prototype.getThresholds = function (params) {
        return this.client.request({
            endpoint: '/classification/internal/thresholds',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add new threshold*/
    HarmonizationThresholdsResource.prototype.postThresholds = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/classification/internal/thresholds',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns thresholds*/
    HarmonizationThresholdsResource.prototype.getThresholdsAndDefault = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/internal/thresholds/default',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update new threshold*/
    HarmonizationThresholdsResource.prototype.putThresholdsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/classification/internal/thresholds/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete threshold*/
    HarmonizationThresholdsResource.prototype.deleteThresholdsById = function (params) {
        return this.client.request({
            endpoint: "/classification/internal/thresholds/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return HarmonizationThresholdsResource;
}($Resource));
export { HarmonizationThresholdsResource };
var HarmonizationUnclassifiedStatisticsResource = /** @class */ (function (_super) {
    __extends(HarmonizationUnclassifiedStatisticsResource, _super);
    function HarmonizationUnclassifiedStatisticsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HarmonizationUnclassifiedStatisticsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/classification/unclassified/statistics',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                status: params.status,
            },
        });
    };
    return HarmonizationUnclassifiedStatisticsResource;
}($Resource));
export { HarmonizationUnclassifiedStatisticsResource };
var Hs6Resource = /** @class */ (function (_super) {
    __extends(Hs6Resource, _super);
    function Hs6Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hs6Resource.prototype.getDescriptionByCode = function (params) {
        return this.client.request({
            endpoint: "/hs6/description/".concat(encodeURIComponent(params.code)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return Hs6Resource;
}($Resource));
export { Hs6Resource };
var InternalDebugTransactionsResource = /** @class */ (function (_super) {
    __extends(InternalDebugTransactionsResource, _super);
    function InternalDebugTransactionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalDebugTransactionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/debug/transactions',
            headers: params.headers,
            method: 'POST',
        });
    };
    return InternalDebugTransactionsResource;
}($Resource));
export { InternalDebugTransactionsResource };
var InternalHarmonizationStatisticsResource = /** @class */ (function (_super) {
    __extends(InternalHarmonizationStatisticsResource, _super);
    function InternalHarmonizationStatisticsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalHarmonizationStatisticsResource.prototype.getRateFreshness = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/rate-freshness',
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
                from: params.from,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getRateSource = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/rate-source',
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getTimeToClassifyAggregated = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/time-to-classify-aggregated',
            headers: params.headers,
            method: 'GET',
            query: {
                from: params.from,
                to: params.to,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getTimeToClassify = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/time-to-classify',
            headers: params.headers,
            method: 'GET',
            query: {
                from: params.from,
                to: params.to,
            },
        });
    };
    return InternalHarmonizationStatisticsResource;
}($Resource));
export { InternalHarmonizationStatisticsResource };
var InternalPaymentRequestsResource = /** @class */ (function (_super) {
    __extends(InternalPaymentRequestsResource, _super);
    function InternalPaymentRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalPaymentRequestsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/payment/requests/").concat(encodeURIComponent(params.id), "/internal"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Cancel the active action & authorization on the payment request*/
    InternalPaymentRequestsResource.prototype.postPaymentAndMethodAndActionAndCancellation = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/payment/requests/").concat(encodeURIComponent(params.id), "/internal/payment/method/action/cancellation"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Update the payment method data to progress the payment through relevant actions*/
    InternalPaymentRequestsResource.prototype.postPaymentAndMethodAndData = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/payment/requests/").concat(encodeURIComponent(params.id), "/internal/payment/method/data"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Update the payment method data to progress the payment through relevant actions*/
    InternalPaymentRequestsResource.prototype.postPaymentMethodData = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/payment/requests/").concat(encodeURIComponent(params.id), "/internal/payment_method_data"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return InternalPaymentRequestsResource;
}($Resource));
export { InternalPaymentRequestsResource };
var InternalPaymentRequestVerificationsResource = /** @class */ (function (_super) {
    __extends(InternalPaymentRequestVerificationsResource, _super);
    function InternalPaymentRequestVerificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalPaymentRequestVerificationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/payment/requests/internal/verification"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return InternalPaymentRequestVerificationsResource;
}($Resource));
export { InternalPaymentRequestVerificationsResource };
var InvariantsResource = /** @class */ (function (_super) {
    __extends(InvariantsResource, _super);
    function InvariantsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvariantsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/invariants',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                since: params.since,
                sort: params.sort,
            },
        });
    };
    return InvariantsResource;
}($Resource));
export { InvariantsResource };
var AdyenDisputeEventsResource = /** @class */ (function (_super) {
    __extends(AdyenDisputeEventsResource, _super);
    function AdyenDisputeEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdyenDisputeEventsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/dispute/callbacks/adyen',
            headers: params.headers,
            method: 'POST',
        });
    };
    return AdyenDisputeEventsResource;
}($Resource));
export { AdyenDisputeEventsResource };
var NotificationRequestsResource = /** @class */ (function (_super) {
    __extends(NotificationRequestsResource, _super);
    function NotificationRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/adyen',
            headers: params.headers,
            method: 'POST',
        });
    };
    return NotificationRequestsResource;
}($Resource));
export { NotificationRequestsResource };
var InvoiceWebhookResponsesResource = /** @class */ (function (_super) {
    __extends(InvoiceWebhookResponsesResource, _super);
    function InvoiceWebhookResponsesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceWebhookResponsesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/bitpay',
            headers: params.headers,
            method: 'POST',
        });
    };
    return InvoiceWebhookResponsesResource;
}($Resource));
export { InvoiceWebhookResponsesResource };
var ItemsResource = /** @class */ (function (_super) {
    __extends(ItemsResource, _super);
    function ItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Update all the items, creating if they does not exist.*/
    ItemsResource.prototype.putBulk = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/catalog/items/bulk"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ItemsResource;
}($Resource));
export { ItemsResource };
var ChannelsResource = /** @class */ (function (_super) {
    __extends(ChannelsResource, _super);
    function ChannelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the list of channels*/
    ChannelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/channels',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ChannelsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/channels',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns a channel by id*/
    ChannelsResource.prototype.getByChannelId = function (params) {
        return this.client.request({
            endpoint: "/internal/channels/".concat(encodeURIComponent(params.channel_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Upserts the channel data, channel is identified by id*/
    ChannelsResource.prototype.putByChannelId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/channels/".concat(encodeURIComponent(params.channel_id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes a channel specified by id*/
    ChannelsResource.prototype.deleteByChannelId = function (params) {
        return this.client.request({
            endpoint: "/internal/channels/".concat(encodeURIComponent(params.channel_id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ChannelsResource;
}($Resource));
export { ChannelsResource };
var ChannelCurrenciesResource = /** @class */ (function (_super) {
    __extends(ChannelCurrenciesResource, _super);
    function ChannelCurrenciesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the list of channel currencies*/
    ChannelCurrenciesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/channel/currencies',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                currency: params.currency,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ChannelCurrenciesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/channel/currencies',
            headers: params.headers,
            method: 'POST',
        });
    };
    ChannelCurrenciesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/currencies/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ChannelCurrenciesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/channel/currencies/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ChannelCurrenciesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/currencies/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ChannelCurrenciesResource;
}($Resource));
export { ChannelCurrenciesResource };
var CheckoutReferencesResource = /** @class */ (function (_super) {
    __extends(CheckoutReferencesResource, _super);
    function CheckoutReferencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutReferencesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/checkout/references"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return CheckoutReferencesResource;
}($Resource));
export { CheckoutReferencesResource };
var UsersResource = /** @class */ (function (_super) {
    __extends(UsersResource, _super);
    function UsersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List pending users*/
    UsersResource.prototype.getPending = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/users/pending',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update the status of this particular user*/
    UsersResource.prototype.putStatusById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/users/".concat(encodeURIComponent(params.id), "/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return UsersResource;
}($Resource));
export { UsersResource };
var CryptoEventsResource = /** @class */ (function (_super) {
    __extends(CryptoEventsResource, _super);
    function CryptoEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CryptoEventsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/cryptopay',
            headers: params.headers,
            method: 'POST',
        });
    };
    return CryptoEventsResource;
}($Resource));
export { CryptoEventsResource };
var ExperiencesResource = /** @class */ (function (_super) {
    __extends(ExperiencesResource, _super);
    function ExperiencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns localized information about 1 or more items given multiple filters. The filter is intended to match an item detail (e.g. number, attributes.product_id, attributes.brand).  The items will be localized based on the experience selected by the query parameters in the order of experience, then country, then ip address.*/
    ExperiencesResource.prototype.postItemsAndFilters = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/items/filters"),
            headers: params.headers,
            method: 'POST',
            query: {
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                price_selector: params.price_selector,
                ship_from_country: params.ship_from_country,
                ship_from_province: params.ship_from_province,
                ship_to_country: params.ship_to_country,
                ship_to_province: params.ship_to_province,
                status: params.status,
            },
        });
    };
    /*Returns localized information about 1 or more items given a filter. The filter is intended to match an item detail (e.g. number, attributes.product_id, attributes.brand).  The items will be localized based on the experience selected by the query parameters in the order of experience, then country, then ip address.*/
    ExperiencesResource.prototype.postItemsAndFiltersByFilter = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/items/filters/").concat(encodeURIComponent(params.filter)),
            headers: params.headers,
            method: 'POST',
            query: {
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                price_selector: params.price_selector,
                ship_from_country: params.ship_from_country,
                ship_from_province: params.ship_from_province,
                ship_to_country: params.ship_to_country,
                ship_to_province: params.ship_to_province,
                status: params.status,
            },
        });
    };
    /*Returns localized information about 0 or more items given a query for the specified experience.*/
    ExperiencesResource.prototype.getItemsAndQueryByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/items/query"),
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                currency: params.currency,
                q: params.q,
            },
        });
    };
    return ExperiencesResource;
}($Resource));
export { ExperiencesResource };
var OrdersResource = /** @class */ (function (_super) {
    __extends(OrdersResource, _super);
    function OrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrdersResource.prototype.getInternalByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/internal/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Redeems all the gift card associated with an order. If a gift card fails, it is removed from the order and an error message is returned.*/
    OrdersResource.prototype.postGiftAndCardAndRedemptionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift/card/redemptions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Adds a gift card to the order*/
    OrdersResource.prototype.postGiftAndCardsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift/cards"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Removes a gift card from the order*/
    OrdersResource.prototype.deleteGiftAndCardsByNumberAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift/cards/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Authorizes any credit payments associated with this order. Call prior to authorizing any credit payments to ensure the correct order balance is used. Any credit payments that fail will be removed.*/
    OrdersResource.prototype.postGiftCardsAndAuthorizeByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/gift_cards/authorize"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Updates the email address associated with this order. Fixes typos automatically (e.g. gmail.con => gmail.com) or if not possible assigns a proxy email address to the order*/
    OrdersResource.prototype.putModificationsAndEmailByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/modifications/email"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Checks to see where an order can be submitted. Will not actually mark the order as submitted. Already submitted orders are given a free pass. This operation may perform some mutation if mutation is the only way to perform the check idempotently (e.g. checks to see if gift cards can be charged may actually charge the card).*/
    OrdersResource.prototype.putSubmissionsAndCheckByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/submissions/check"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrdersResource;
}($Resource));
export { OrdersResource };
var PaypalDisputeEventsResource = /** @class */ (function (_super) {
    __extends(PaypalDisputeEventsResource, _super);
    function PaypalDisputeEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaypalDisputeEventsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/dispute/callbacks/paypal',
            headers: params.headers,
            method: 'POST',
        });
    };
    return PaypalDisputeEventsResource;
}($Resource));
export { PaypalDisputeEventsResource };
var WebhookEventsResource = /** @class */ (function (_super) {
    __extends(WebhookEventsResource, _super);
    function WebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebhookEventsResource.prototype.postDisputeAndNotificationsAndPaypal = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/dispute/notifications/paypal',
            headers: params.headers,
            method: 'POST',
        });
    };
    WebhookEventsResource.prototype.postPaymentAndCallbacksAndPaypal = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/paypal',
            headers: params.headers,
            method: 'POST',
        });
    };
    return WebhookEventsResource;
}($Resource));
export { WebhookEventsResource };
var UltimateBeneficiaryOwnersResource = /** @class */ (function (_super) {
    __extends(UltimateBeneficiaryOwnersResource, _super);
    function UltimateBeneficiaryOwnersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UltimateBeneficiaryOwnersResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/ultimate/beneficiary/owner"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return UltimateBeneficiaryOwnersResource;
}($Resource));
export { UltimateBeneficiaryOwnersResource };
var OrderManagementEventsResource = /** @class */ (function (_super) {
    __extends(OrderManagementEventsResource, _super);
    function OrderManagementEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Order lifecycle events are designed to trigger exactly once automatically. This endpoint can be used to regenerate an event by customer request.*/
    OrderManagementEventsResource.prototype.postReplayByOrderLifecycleEvent = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/lifecycle/events/").concat(encodeURIComponent(params.order_lifecycle_event), "/replay"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrderManagementEventsResource;
}($Resource));
export { OrderManagementEventsResource };
var OnboardingStatesResource = /** @class */ (function (_super) {
    __extends(OnboardingStatesResource, _super);
    function OnboardingStatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateAndBlockByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/block"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateAndRecalculateByOrganization = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/recalculate"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateAndTransitionAndReplaceByOrganizationAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/transition/replace/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OnboardingStatesResource.prototype.deleteInternalAndOnboardingAndStateAndTransitionByOrganizationAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/transition/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateAndTransitionsAndDeleteByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/transitions/delete"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OnboardingStatesResource.prototype.putInternalAndOnboardingAndStateAndUnblockByOrganization = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/onboarding/state/unblock"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OnboardingStatesResource;
}($Resource));
export { OnboardingStatesResource };
var MembershipsResource = /** @class */ (function (_super) {
    __extends(MembershipsResource, _super);
    function MembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MembershipsResource.prototype.postAcceptAndAll = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/invitations/accept/all',
            headers: params.headers,
            method: 'POST',
        });
    };
    return MembershipsResource;
}($Resource));
export { MembershipsResource };
var AuthorizationsResource = /** @class */ (function (_super) {
    __extends(AuthorizationsResource, _super);
    function AuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates inline authorization parameters that are required in order to show payment methods like Paypal and Google Pay.*/
    AuthorizationsResource.prototype.postParameters = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/authorizations/parameters"),
            headers: params.headers,
            method: 'POST',
        });
    };
    AuthorizationsResource.prototype.getMetadataByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/authorizations/").concat(encodeURIComponent(params.key), "/metadata"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Idempotently upserts an authorization's payload. For example, this endpoint can be used to complete a pending Apple Pay authorization by providing the payment token.*/
    AuthorizationsResource.prototype.putPayloadByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/authorizations/").concat(encodeURIComponent(params.key), "/payload"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    AuthorizationsResource.prototype.postPaymentAndDetailsAndAdyenByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/authorizations/").concat(encodeURIComponent(params.key), "/payment/details/adyen"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return AuthorizationsResource;
}($Resource));
export { AuthorizationsResource };
var PermissionAuditsResource = /** @class */ (function (_super) {
    __extends(PermissionAuditsResource, _super);
    function PermissionAuditsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List all permitted routes and behaviors known to flow, along with the roles and authentication techniques that could be used to connect to them.*/
    PermissionAuditsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/permission/audits',
            headers: params.headers,
            method: 'GET',
        });
    };
    return PermissionAuditsResource;
}($Resource));
export { PermissionAuditsResource };
var SimplePermissionChecksResource = /** @class */ (function (_super) {
    __extends(SimplePermissionChecksResource, _super);
    function SimplePermissionChecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a 200 with any additional behaviors if the current request has access to the specified path or a 403 detailing the missing permissions and how to get them. Used by services to permit access.*/
    SimplePermissionChecksResource.prototype.getPermissionAndChecks = function (params) {
        return this.client.request({
            endpoint: '/permission/checks',
            headers: params.headers,
            method: 'GET',
            query: {
                path: params.path,
                verb: params.verb,
            },
        });
    };
    /*Returns a 200 with any additional behaviors if the current request has access to the specified path or a 403 detailing the missing permissions and how to get them. Used by services to permit access.*/
    SimplePermissionChecksResource.prototype.getPermissionAndChecksByOrganization = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/permission/checks"),
            headers: params.headers,
            method: 'GET',
            query: {
                path: params.path,
                verb: params.verb,
            },
        });
    };
    return SimplePermissionChecksResource;
}($Resource));
export { SimplePermissionChecksResource };
var QueryBuildersResource = /** @class */ (function (_super) {
    __extends(QueryBuildersResource, _super);
    function QueryBuildersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryBuildersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/query/builders"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return QueryBuildersResource;
}($Resource));
export { QueryBuildersResource };
var RatecardsResource = /** @class */ (function (_super) {
    __extends(RatecardsResource, _super);
    function RatecardsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Outputs a full ratecard, including all fees and rates, in a CSV format.*/
    RatecardsResource.prototype.getExportById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/ratecards/").concat(encodeURIComponent(params.id), "/export"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RatecardsResource;
}($Resource));
export { RatecardsResource };
var ServiceFeesResource = /** @class */ (function (_super) {
    __extends(ServiceFeesResource, _super);
    function ServiceFeesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceFeesResource.prototype.putFuelAndSurchargesByServiceId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/ratecard/service/fees/".concat(encodeURIComponent(params.service_id), "/fuel/surcharges"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ServiceFeesResource;
}($Resource));
export { ServiceFeesResource };
var CountriesResource = /** @class */ (function (_super) {
    __extends(CountriesResource, _super);
    function CountriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/reports/destinations/countries"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CountriesResource;
}($Resource));
export { CountriesResource };
var OrganizationSessionsResource = /** @class */ (function (_super) {
    __extends(OrganizationSessionsResource, _super);
    function OrganizationSessionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationSessionsResource.prototype.postOrganizationsByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/organizations/".concat(encodeURIComponent(params.organization)),
            headers: params.headers,
            method: 'POST',
        });
    };
    OrganizationSessionsResource.prototype.getBySession = function (params) {
        return this.client.request({
            endpoint: "/sfcc/sessions/".concat(encodeURIComponent(params.session)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationSessionsResource.prototype.putBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/".concat(encodeURIComponent(params.session)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrganizationSessionsResource.prototype.deleteBySession = function (params) {
        return this.client.request({
            endpoint: "/sfcc/sessions/".concat(encodeURIComponent(params.session)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    OrganizationSessionsResource.prototype.putOrganizationsBySessionAndOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/".concat(encodeURIComponent(params.session), "/organizations/").concat(encodeURIComponent(params.organization)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Resets the session based on the provided geo parameters.*/
    OrganizationSessionsResource.prototype.putResetBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/".concat(encodeURIComponent(params.session), "/reset"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrganizationSessionsResource;
}($Resource));
export { OrganizationSessionsResource };
var ShopifyOrdersResource = /** @class */ (function (_super) {
    __extends(ShopifyOrdersResource, _super);
    function ShopifyOrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyOrdersResource.prototype.getTraceByShopifyOrderId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/order/trace/").concat(encodeURIComponent(params.shopify_order_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyOrdersResource;
}($Resource));
export { ShopifyOrdersResource };
var KnowYourBusinessesResource = /** @class */ (function (_super) {
    __extends(KnowYourBusinessesResource, _super);
    function KnowYourBusinessesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KnowYourBusinessesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/merchant/config/know/your/business"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                sort: params.sort,
            },
        });
    };
    return KnowYourBusinessesResource;
}($Resource));
export { KnowYourBusinessesResource };
var ShopifyCartsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartsResource, _super);
    function ShopifyCartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Set the promotion code on the cart - shopify only supports up to 1 promotion code. If the cart already had another promotion code, replaces that code with the provided one.*/
    ShopifyCartsResource.prototype.putShopifyAndCartsAndPromotionById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/".concat(encodeURIComponent(params.id), "/promotion"),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code*/
    ShopifyCartsResource.prototype.deleteShopifyAndCartsAndPromotionById = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/".concat(encodeURIComponent(params.id), "/promotion"),
            headers: params.headers,
            method: 'DELETE',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Create a shopify cart from a flow order*/
    ShopifyCartsResource.prototype.postShopifyAndCartsAndFlowAndOrderByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/carts/flow/order"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyCartsResource;
}($Resource));
export { ShopifyCartsResource };
var ShopifyCartConversionsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartConversionsResource, _super);
    function ShopifyCartConversionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates a checkout from a shopify cart*/
    ShopifyCartConversionsResource.prototype.postCheckouts = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/shopify/cart/checkouts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyCartConversionsResource;
}($Resource));
export { ShopifyCartConversionsResource };
var ShopifyLocalizedVariantsResource = /** @class */ (function (_super) {
    __extends(ShopifyLocalizedVariantsResource, _super);
    function ShopifyLocalizedVariantsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyLocalizedVariantsResource.prototype.getExperienceAndMapByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/localized/variants/experience/").concat(encodeURIComponent(params.experience_key), "/map"),
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                currency: params.currency,
                handle: params.handle,
                variant_id: params.variant_id,
            },
        });
    };
    return ShopifyLocalizedVariantsResource;
}($Resource));
export { ShopifyLocalizedVariantsResource };
var StripeDisputeEventsResource = /** @class */ (function (_super) {
    __extends(StripeDisputeEventsResource, _super);
    function StripeDisputeEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeDisputeEventsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/dispute/callbacks/stripe',
            headers: params.headers,
            method: 'POST',
        });
    };
    return StripeDisputeEventsResource;
}($Resource));
export { StripeDisputeEventsResource };
var StripeEventsResource = /** @class */ (function (_super) {
    __extends(StripeEventsResource, _super);
    function StripeEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeEventsResource.prototype.postStripe = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/stripe',
            headers: params.headers,
            method: 'POST',
        });
    };
    return StripeEventsResource;
}($Resource));
export { StripeEventsResource };
var ChannelTokensResource = /** @class */ (function (_super) {
    __extends(ChannelTokensResource, _super);
    function ChannelTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates a channel token*/
    ChannelTokensResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/channel/tokens',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ChannelTokensResource;
}($Resource));
export { ChannelTokensResource };
var ItemClassificationsResource = /** @class */ (function (_super) {
    __extends(ItemClassificationsResource, _super);
    function ItemClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemClassificationsResource.prototype.postPredict = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/predict',
            headers: params.headers,
            method: 'POST',
        });
    };
    ItemClassificationsResource.prototype.postV2AndPredict = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/v2/predict',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ItemClassificationsResource;
}($Resource));
export { ItemClassificationsResource };
var ItemClassificationSummariesResource = /** @class */ (function (_super) {
    __extends(ItemClassificationSummariesResource, _super);
    function ItemClassificationSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get item classifications*/
    ItemClassificationSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/classification/item/summary"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return ItemClassificationSummariesResource;
}($Resource));
export { ItemClassificationSummariesResource };
var ItemHarmonizationsResource = /** @class */ (function (_super) {
    __extends(ItemHarmonizationsResource, _super);
    function ItemHarmonizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get the latest harmonization results for the specified item numbers.*/
    ItemHarmonizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/results/items"),
            headers: params.headers,
            method: 'GET',
            query: {
                number: params.number,
            },
        });
    };
    return ItemHarmonizationsResource;
}($Resource));
export { ItemHarmonizationsResource };
var ItemRestrictionsResource = /** @class */ (function (_super) {
    __extends(ItemRestrictionsResource, _super);
    function ItemRestrictionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of restricted items and the regions in which they are restricted.*/
    ItemRestrictionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Restricts all items corresponding with the provided numbers in the provided regions.*/
    ItemRestrictionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*For the item with the provided number, updates the regions in which the item restriction applies.*/
    ItemRestrictionsResource.prototype.putItemByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions/item/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes an item restriction by item number.*/
    ItemRestrictionsResource.prototype.deleteItemByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions/item/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*For the item restriction with the provided id, updates the regions in which the item restriction applies.*/
    ItemRestrictionsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes an item restriction by id.*/
    ItemRestrictionsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/item-restrictions/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ItemRestrictionsResource;
}($Resource));
export { ItemRestrictionsResource };
var ItemSalesMarginsResource = /** @class */ (function (_super) {
    __extends(ItemSalesMarginsResource, _super);
    function ItemSalesMarginsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemSalesMarginsResource.prototype.getSalesMargins = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ItemSalesMarginsResource.prototype.postSalesMargins = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ItemSalesMarginsResource.prototype.getSalesMarginsAndVersions = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ItemSalesMarginsResource.prototype.getSalesMarginsByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ItemSalesMarginsResource.prototype.putSalesMarginsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ItemSalesMarginsResource.prototype.deleteSalesMarginsByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experiences/").concat(encodeURIComponent(params.experience_key), "/sales-margins/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ItemSalesMarginsResource;
}($Resource));
export { ItemSalesMarginsResource };
var JeanDemoItemsResource = /** @class */ (function (_super) {
    __extends(JeanDemoItemsResource, _super);
    function JeanDemoItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JeanDemoItemsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/jean/items',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    JeanDemoItemsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/jean/items/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return JeanDemoItemsResource;
}($Resource));
export { JeanDemoItemsResource };
var KeysResource = /** @class */ (function (_super) {
    __extends(KeysResource, _super);
    function KeysResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeysResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/keys"),
            headers: params.headers,
            method: 'GET',
        });
    };
    KeysResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/keys"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return KeysResource;
}($Resource));
export { KeysResource };
var LabProjectSettingsResource = /** @class */ (function (_super) {
    __extends(LabProjectSettingsResource, _super);
    function LabProjectSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabProjectSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/lab/project/settings"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    LabProjectSettingsResource.prototype.getByFlowLabProjectKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/lab/project/settings/").concat(encodeURIComponent(params.flow_lab_project_key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    LabProjectSettingsResource.prototype.putByFlowLabProjectKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/lab/project/settings/").concat(encodeURIComponent(params.flow_lab_project_key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LabProjectSettingsResource;
}($Resource));
export { LabProjectSettingsResource };
var LabelCreationJobsResource = /** @class */ (function (_super) {
    __extends(LabelCreationJobsResource, _super);
    function LabelCreationJobsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelCreationJobsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/label/creation/requests',
            headers: params.headers,
            method: 'POST',
        });
    };
    LabelCreationJobsResource.prototype.putCancelByReferenceId = function (params) {
        return this.client.request({
            endpoint: "/internal/label/creation/requests/cancel/".concat(encodeURIComponent(params.reference_id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    LabelCreationJobsResource.prototype.getByReferenceId = function (params) {
        return this.client.request({
            endpoint: "/internal/label/creation/requests/".concat(encodeURIComponent(params.reference_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LabelCreationJobsResource;
}($Resource));
export { LabelCreationJobsResource };
var LabelGenerationSettingsResource = /** @class */ (function (_super) {
    __extends(LabelGenerationSettingsResource, _super);
    function LabelGenerationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelGenerationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/label/generation/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    LabelGenerationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/label/generation/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    LabelGenerationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/label/generation/settings"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return LabelGenerationSettingsResource;
}($Resource));
export { LabelGenerationSettingsResource };
var LabelRequestResultsResource = /** @class */ (function (_super) {
    __extends(LabelRequestResultsResource, _super);
    function LabelRequestResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelRequestResultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/logistics/label/request/result',
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_id: params.carrier_id,
                created_at_from: params.created_at_from,
                created_at_to: params.created_at_to,
                destination_country: params.destination_country,
                errors_only: params.errors_only,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                organization_id: params.organization_id,
                organization_type: params.organization_type,
                sort: params.sort,
            },
        });
    };
    return LabelRequestResultsResource;
}($Resource));
export { LabelRequestResultsResource };
var LabelTaxonomyResource = /** @class */ (function (_super) {
    __extends(LabelTaxonomyResource, _super);
    function LabelTaxonomyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelTaxonomyResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/label_taxonomy',
            headers: params.headers,
            method: 'GET',
        });
    };
    return LabelTaxonomyResource;
}($Resource));
export { LabelTaxonomyResource };
var LevyRateSummariesResource = /** @class */ (function (_super) {
    __extends(LevyRateSummariesResource, _super);
    function LevyRateSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LevyRateSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/levy/rate/summary"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LevyRateSummariesResource;
}($Resource));
export { LevyRateSummariesResource };
var LiabilityRemittancePlansResource = /** @class */ (function (_super) {
    __extends(LiabilityRemittancePlansResource, _super);
    function LiabilityRemittancePlansResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LiabilityRemittancePlansResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/liabilities"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    LiabilityRemittancePlansResource.prototype.getByOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/liabilities/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LiabilityRemittancePlansResource;
}($Resource));
export { LiabilityRemittancePlansResource };
var LocalizableContentsResource = /** @class */ (function (_super) {
    __extends(LocalizableContentsResource, _super);
    function LocalizableContentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retreives blocks of translated content for the target schema and locale. If no localization exists for the target locale, the source content will be returned instead.*/
    LocalizableContentsResource.prototype.getContentAndSchemasBySchemaKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/content/schemas/").concat(encodeURIComponent(params.schema_key)),
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    /*Retreives blocks of translated content for the target locale using a content id.  If no localization exists for the target locale, the source content will be returned instead.*/
    LocalizableContentsResource.prototype.getContentsAndLocalizationByContentId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents/").concat(encodeURIComponent(params.content_id), "/localization"),
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    return LocalizableContentsResource;
}($Resource));
export { LocalizableContentsResource };
var LocalizationsResource = /** @class */ (function (_super) {
    __extends(LocalizationsResource, _super);
    function LocalizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents/").concat(encodeURIComponent(params.content_id), "/localizations"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                locale: params.locale,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    LocalizationsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents/").concat(encodeURIComponent(params.content_id), "/localizations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Allows for patch updates to the value of a single block of translated content.*/
    LocalizationsResource.prototype.putElementsByIdAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents/").concat(encodeURIComponent(params.content_id), "/localizations/").concat(encodeURIComponent(params.id), "/elements/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizationsResource;
}($Resource));
export { LocalizationsResource };
var LocalizedContentsResource = /** @class */ (function (_super) {
    __extends(LocalizedContentsResource, _super);
    function LocalizedContentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizedContentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                schema_key: params.schema_key,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    LocalizedContentsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/contents/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizedContentsResource;
}($Resource));
export { LocalizedContentsResource };
var LocalizedItemsExportSettingsResource = /** @class */ (function (_super) {
    __extends(LocalizedItemsExportSettingsResource, _super);
    function LocalizedItemsExportSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizedItemsExportSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/settings/export/localized_items"),
            headers: params.headers,
            method: 'GET',
        });
    };
    LocalizedItemsExportSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/settings/export/localized_items"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizedItemsExportSettingsResource;
}($Resource));
export { LocalizedItemsExportSettingsResource };
var LogisticsCapabilitiesResource = /** @class */ (function (_super) {
    __extends(LogisticsCapabilitiesResource, _super);
    function LogisticsCapabilitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the logistics capabilities for an organization*/
    LogisticsCapabilitiesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/logistics/capabilities"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Upserts the logistics capabilities for an organization*/
    LogisticsCapabilitiesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/logistics/capabilities"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LogisticsCapabilitiesResource;
}($Resource));
export { LogisticsCapabilitiesResource };
var LogisticsPayoutRequestsResource = /** @class */ (function (_super) {
    __extends(LogisticsPayoutRequestsResource, _super);
    function LogisticsPayoutRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Handles a payout request for a order and carrier tracking number*/
    LogisticsPayoutRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/logistics/payout_request',
            headers: params.headers,
            method: 'POST',
            query: {
                dry_run: params.dry_run,
            },
        });
    };
    return LogisticsPayoutRequestsResource;
}($Resource));
export { LogisticsPayoutRequestsResource };
var LostChargebacksResource = /** @class */ (function (_super) {
    __extends(LostChargebacksResource, _super);
    function LostChargebacksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LostChargebacksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/lost/chargebacks',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                organization_id: params.organization_id,
                sort: params.sort,
            },
        });
    };
    LostChargebacksResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/lost/chargebacks/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    LostChargebacksResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/lost/chargebacks/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    LostChargebacksResource.prototype.putByOrganizationIdAndOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/lost/chargebacks/".concat(encodeURIComponent(params.organization_id), "/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LostChargebacksResource;
}($Resource));
export { LostChargebacksResource };
var LoyaltyProgramsResource = /** @class */ (function (_super) {
    __extends(LoyaltyProgramsResource, _super);
    function LoyaltyProgramsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoyaltyProgramsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/loyalty/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    LoyaltyProgramsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/loyalty/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'POST',
        });
    };
    LoyaltyProgramsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/loyalty/").concat(encodeURIComponent(params.number), "/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return LoyaltyProgramsResource;
}($Resource));
export { LoyaltyProgramsResource };
var ManualReviewRulesResource = /** @class */ (function (_super) {
    __extends(ManualReviewRulesResource, _super);
    function ManualReviewRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about manual review rules for an organization.*/
    ManualReviewRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/manual/rules"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Retrieves details about a manual review rule based on the responsible party.*/
    ManualReviewRulesResource.prototype.getByResponsibleParty = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/manual/rules/").concat(encodeURIComponent(params.responsible_party)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Upserts a manual review rule based on the responsible party (one rule per responsible party)*/
    ManualReviewRulesResource.prototype.putByResponsibleParty = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/manual/rules/").concat(encodeURIComponent(params.responsible_party)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes a manual review rule based on the responsible party*/
    ManualReviewRulesResource.prototype.deleteByResponsibleParty = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/fraud/manual/rules/").concat(encodeURIComponent(params.responsible_party)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ManualReviewRulesResource;
}($Resource));
export { ManualReviewRulesResource };
var MarketingGatewayChannelsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayChannelsResource, _super);
    function MarketingGatewayChannelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayChannelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/channels"),
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayChannelsResource.prototype.postNewChannelRequest = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/channels/new_channel_request"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayChannelsResource.prototype.putConnectByChannelId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/channels/").concat(encodeURIComponent(params.channel_id), "/connect"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayChannelsResource.prototype.putDisconnectByChannelId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/channels/").concat(encodeURIComponent(params.channel_id), "/disconnect"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayChannelsResource.prototype.getFeedsAndDownloadsByChannelIdAndFeedAndFormat = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/channels/").concat(encodeURIComponent(params.channel_id), "/feeds/").concat(encodeURIComponent(params.feed), "/downloads/").concat(encodeURIComponent(params.format)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayChannelsResource;
}($Resource));
export { MarketingGatewayChannelsResource };
var MarketingGatewayChannelSourceSummariesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayChannelSourceSummariesResource, _super);
    function MarketingGatewayChannelSourceSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayChannelSourceSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/accounts"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Registers a platform/account pair as a channel of interest for the purposes of creating localized feeds*/
    MarketingGatewayChannelSourceSummariesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/accounts"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayChannelSourceSummariesResource;
}($Resource));
export { MarketingGatewayChannelSourceSummariesResource };
var MarketingGatewayFacebookBusinessesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookBusinessesResource, _super);
    function MarketingGatewayFacebookBusinessesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookBusinessesResource.prototype.getCatalogs = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook/").concat(encodeURIComponent(params.business_id), "/catalogs"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFacebookBusinessesResource;
}($Resource));
export { MarketingGatewayFacebookBusinessesResource };
var MarketingGatewayFacebookConnectionsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionsResource, _super);
    function MarketingGatewayFacebookConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook"),
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.putCatalog = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook/catalog"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayFacebookConnectionsResource;
}($Resource));
export { MarketingGatewayFacebookConnectionsResource };
var MarketingGatewayFacebookConnectionAccessTokenSummariesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionAccessTokenSummariesResource, _super);
    function MarketingGatewayFacebookConnectionAccessTokenSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionAccessTokenSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/facebook/access_token_summary"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFacebookConnectionAccessTokenSummariesResource;
}($Resource));
export { MarketingGatewayFacebookConnectionAccessTokenSummariesResource };
var MarketingGatewayFacebookConnectionDeauthsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionDeauthsResource, _super);
    function MarketingGatewayFacebookConnectionDeauthsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionDeauthsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/marketing/gateway/facebook/deauth',
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFacebookConnectionDeauthsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/marketing/gateway/facebook/deauth',
            headers: params.headers,
            method: 'POST',
            query: {
                signed_request: params.signed_request,
            },
        });
    };
    return MarketingGatewayFacebookConnectionDeauthsResource;
}($Resource));
export { MarketingGatewayFacebookConnectionDeauthsResource };
var MarketingGatewayFeedsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedsResource, _super);
    function MarketingGatewayFeedsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFeedsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds"),
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                schema_compatibility: params.schema_compatibility,
            },
        });
    };
    MarketingGatewayFeedsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.postBulk = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds/bulk"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.postExport = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds/export"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.getByFeed = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds/").concat(encodeURIComponent(params.feed)),
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFeedsResource.prototype.deleteByFeed = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds/").concat(encodeURIComponent(params.feed)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayFeedsResource.prototype.getDownloadsByFeedAndFormat = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feeds/").concat(encodeURIComponent(params.feed), "/downloads/").concat(encodeURIComponent(params.format)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFeedsResource;
}($Resource));
export { MarketingGatewayFeedsResource };
var MarketingGatewayFeedFormsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedFormsResource, _super);
    function MarketingGatewayFeedFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides list of feed forms (for markets) that do not yet exist and therefore can be created.*/
    MarketingGatewayFeedFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feed/forms"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return MarketingGatewayFeedFormsResource;
}($Resource));
export { MarketingGatewayFeedFormsResource };
var MarketingGatewayFeedSourcesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedSourcesResource, _super);
    function MarketingGatewayFeedSourcesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides list of data sources that can be used to create feeds from.*/
    MarketingGatewayFeedSourcesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/feed/sources"),
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
            },
        });
    };
    return MarketingGatewayFeedSourcesResource;
}($Resource));
export { MarketingGatewayFeedSourcesResource };
var MarketingGatewayGoogleConnectionsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayGoogleConnectionsResource, _super);
    function MarketingGatewayGoogleConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayGoogleConnectionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/google"),
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/google"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/google"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.putAccount = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/google/account"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayGoogleConnectionsResource;
}($Resource));
export { MarketingGatewayGoogleConnectionsResource };
var MarketingGatewayLocalizedItemsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayLocalizedItemsResource, _super);
    function MarketingGatewayLocalizedItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides random list of localized items given a feed form.*/
    MarketingGatewayLocalizedItemsResource.prototype.postRandom = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/marketing/gateway/items/random"),
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
            },
        });
    };
    return MarketingGatewayLocalizedItemsResource;
}($Resource));
export { MarketingGatewayLocalizedItemsResource };
var MarketsOrdersResource = /** @class */ (function (_super) {
    __extends(MarketsOrdersResource, _super);
    function MarketsOrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Cancel order*/
    MarketsOrdersResource.prototype.postCancelById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/").concat(encodeURIComponent(params.id), "/cancel"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Endpoint to inject an order directly to into Flow, bypassing Checkout and Flow's order APIs. For testing purposes.*/
    MarketsOrdersResource.prototype.postByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Updates the destination address for an order*/
    MarketsOrdersResource.prototype.putDestinationByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/").concat(encodeURIComponent(params.number), "/destination"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Replay order (resulting in new events on the latest code based off the same inputs)*/
    MarketsOrdersResource.prototype.postReplayByNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/").concat(encodeURIComponent(params.number), "/replay"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return MarketsOrdersResource;
}($Resource));
export { MarketsOrdersResource };
var MarketsOrderSummariesResource = /** @class */ (function (_super) {
    __extends(MarketsOrderSummariesResource, _super);
    function MarketsOrderSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to fetch Shopify order summaries*/
    MarketsOrderSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/summary"),
            headers: params.headers,
            method: 'GET',
            query: {
                from: params.from,
                to: params.to,
            },
        });
    };
    return MarketsOrderSummariesResource;
}($Resource));
export { MarketsOrderSummariesResource };
var MerchantApplicationSummariesResource = /** @class */ (function (_super) {
    __extends(MerchantApplicationSummariesResource, _super);
    function MerchantApplicationSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the list of onboarding applications in a channel.*/
    MerchantApplicationSummariesResource.prototype.getChannelAndMerchantAndApplicationAndSummariesByChannelId = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/merchant/application/summaries"),
            headers: params.headers,
            method: 'GET',
            query: {
                created_at_from: params.created_at_from,
                created_at_to: params.created_at_to,
                id: params.id,
                legal_name_contains: params.legal_name_contains,
                limit: params.limit,
                offset: params.offset,
                organization_id_contains: params.organization_id_contains,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    MerchantApplicationSummariesResource.prototype.getChannelAndMerchantAndApplicationAndSummariesAndV2ByChannelId = function (params) {
        return this.client.request({
            endpoint: "/channel/".concat(encodeURIComponent(params.channel_id), "/merchant/application/summaries/v2"),
            headers: params.headers,
            method: 'GET',
            query: {
                created_at_from: params.created_at_from,
                created_at_to: params.created_at_to,
                id: params.id,
                legal_name_contains: params.legal_name_contains,
                limit: params.limit,
                offset: params.offset,
                organization_id_contains: params.organization_id_contains,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return MerchantApplicationSummariesResource;
}($Resource));
export { MerchantApplicationSummariesResource };
var MerchantHubOverridesResource = /** @class */ (function (_super) {
    __extends(MerchantHubOverridesResource, _super);
    function MerchantHubOverridesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MerchantHubOverridesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant_hub_override"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    MerchantHubOverridesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant_hub_override"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MerchantHubOverridesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant_hub_override/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    MerchantHubOverridesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant_hub_override/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MerchantHubOverridesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant_hub_override/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return MerchantHubOverridesResource;
}($Resource));
export { MerchantHubOverridesResource };
var MerchantOfRecordEntitySettingsResource = /** @class */ (function (_super) {
    __extends(MerchantOfRecordEntitySettingsResource, _super);
    function MerchantOfRecordEntitySettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MerchantOfRecordEntitySettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant-of-record-entity"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                names: params.names,
                offset: params.offset,
                sort: params.sort,
                starts_at: params.starts_at,
            },
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant-of-record-entity"),
            headers: params.headers,
            method: 'POST',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant-of-record-entity/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant-of-record-entity/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant-of-record-entity/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return MerchantOfRecordEntitySettingsResource;
}($Resource));
export { MerchantOfRecordEntitySettingsResource };
var NegativeDebitMetricsResource = /** @class */ (function (_super) {
    __extends(NegativeDebitMetricsResource, _super);
    function NegativeDebitMetricsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to fetch negative debits metrics*/
    NegativeDebitMetricsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/negative/debit/metrics',
            headers: params.headers,
            method: 'GET',
            query: {
                payout_date: params.payout_date,
            },
        });
    };
    return NegativeDebitMetricsResource;
}($Resource));
export { NegativeDebitMetricsResource };
var OnboardingAuditReportsResource = /** @class */ (function (_super) {
    __extends(OnboardingAuditReportsResource, _super);
    function OnboardingAuditReportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns an onboarding audit report for a merchant.*/
    OnboardingAuditReportsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization_id), "/onboarding/audit"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OnboardingAuditReportsResource;
}($Resource));
export { OnboardingAuditReportsResource };
var OnboardingAuditSnapshotsResource = /** @class */ (function (_super) {
    __extends(OnboardingAuditSnapshotsResource, _super);
    function OnboardingAuditSnapshotsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns historical organization audit snapshots sorted by created_at desc.*/
    OnboardingAuditSnapshotsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization_id), "/onboarding/audit/snapshots"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return OnboardingAuditSnapshotsResource;
}($Resource));
export { OnboardingAuditSnapshotsResource };
var OnboardingOrganizationsResource = /** @class */ (function (_super) {
    __extends(OnboardingOrganizationsResource, _super);
    function OnboardingOrganizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of organizations with their associated merchant application and onboarding state based on filters*/
    OnboardingOrganizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/".concat(encodeURIComponent(params.channel_id), "/onboarding/organizations"),
            headers: params.headers,
            method: 'GET',
            query: {
                activated_at_from: params.activated_at_from,
                activated_at_to: params.activated_at_to,
                application_received_from: params.application_received_from,
                application_received_to: params.application_received_to,
                audit_categories_warned_or_failed: params.audit_categories_warned_or_failed,
                compliance_full_review_required: params.compliance_full_review_required,
                id: params.id,
                last_audit_result: params.last_audit_result,
                legal_name_contains: params.legal_name_contains,
                limit: params.limit,
                offset: params.offset,
                onboarding_states: params.onboarding_states,
                organization_id_contains: params.organization_id_contains,
                setup_completed_at_from: params.setup_completed_at_from,
                setup_completed_at_to: params.setup_completed_at_to,
                shop_name_contains: params.shop_name_contains,
                sort: params.sort,
            },
        });
    };
    /*Search merchants against organizationId, Shop Name or Legal Name*/
    OnboardingOrganizationsResource.prototype.getSearch = function (params) {
        return this.client.request({
            endpoint: "/internal/channel/".concat(encodeURIComponent(params.channel_id), "/onboarding/organizations/search"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    return OnboardingOrganizationsResource;
}($Resource));
export { OnboardingOrganizationsResource };
var OptinAttributesResource = /** @class */ (function (_super) {
    __extends(OptinAttributesResource, _super);
    function OptinAttributesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptinAttributesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/attributes"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                optin_attribute_key: params.optin_attribute_key,
                sort: params.sort,
            },
        });
    };
    OptinAttributesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/attributes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OptinAttributesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/attributes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OptinAttributesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/attributes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OptinAttributesResource;
}($Resource));
export { OptinAttributesResource };
var OptinPromptsResource = /** @class */ (function (_super) {
    __extends(OptinPromptsResource, _super);
    function OptinPromptsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptinPromptsResource.prototype.getPrompts = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/prompts"),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                optin_attribute_key: params.optin_attribute_key,
                region: params.region,
                sort: params.sort,
            },
        });
    };
    OptinPromptsResource.prototype.postPrompts = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/prompts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    OptinPromptsResource.prototype.putPromptsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/prompts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OptinPromptsResource.prototype.deletePromptsById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/prompts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*This anonymous path will allow consumers to receive a targeted list of prompts that should apply in their region.*/
    OptinPromptsResource.prototype.getTargetsByTargetAndRegion = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/targets/").concat(encodeURIComponent(params.target), "/").concat(encodeURIComponent(params.region)),
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                expand: params.expand,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    OptinPromptsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/optin/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    return OptinPromptsResource;
}($Resource));
export { OptinPromptsResource };
var OptinPromptCopiesResource = /** @class */ (function (_super) {
    __extends(OptinPromptCopiesResource, _super);
    function OptinPromptCopiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Copies all active opt-ins along with their content and translations from the source org to each of the orgs specified in the body. If the current user does not have permissions to create content for one of these orgs, this will result in a 422. Other orgs will complete.*/
    OptinPromptCopiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/optin/prompt/copies',
            headers: params.headers,
            method: 'POST',
        });
    };
    return OptinPromptCopiesResource;
}($Resource));
export { OptinPromptCopiesResource };
var OrderActionabilitiesResource = /** @class */ (function (_super) {
    __extends(OrderActionabilitiesResource, _super);
    function OrderActionabilitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Attempts to take an action or set of line quantity actions on an order.*/
    OrderActionabilitiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/status/actions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns the current actionability for this order*/
    OrderActionabilitiesResource.prototype.getAvailable = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/status/actions/available"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderActionabilitiesResource;
}($Resource));
export { OrderActionabilitiesResource };
var OrderAddressValidationsResource = /** @class */ (function (_super) {
    __extends(OrderAddressValidationsResource, _super);
    function OrderAddressValidationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderAddressValidationsResource.prototype.getOrderValidationAndFailures = function (params) {
        return this.client.request({
            endpoint: '/internal/label/order_validation/failures',
            headers: params.headers,
            method: 'GET',
            query: {
                channel: params.channel,
                include_cancelled_orders: params.include_cancelled_orders,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    OrderAddressValidationsResource.prototype.postAddressValidationByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/label/".concat(encodeURIComponent(params.organization), "/address_validation"),
            headers: params.headers,
            method: 'POST',
        });
    };
    OrderAddressValidationsResource.prototype.getOrderValidationByOrganizationAndOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/internal/label/".concat(encodeURIComponent(params.organization), "/order_validation/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderAddressValidationsResource;
}($Resource));
export { OrderAddressValidationsResource };
var OrderCancellationsResource = /** @class */ (function (_super) {
    __extends(OrderCancellationsResource, _super);
    function OrderCancellationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderCancellationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/order/cancellations',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                organization_id: params.organization_id,
                sort: params.sort,
            },
        });
    };
    OrderCancellationsResource.prototype.putOrganizationAndOrderByOrganizationIdAndNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/billing/order/cancellations/organization/".concat(encodeURIComponent(params.organization_id), "/order/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrderCancellationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/order/cancellations/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrderCancellationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/order/cancellations/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrderCancellationsResource;
}($Resource));
export { OrderCancellationsResource };
var OrderCombinedShipmentsResource = /** @class */ (function (_super) {
    __extends(OrderCombinedShipmentsResource, _super);
    function OrderCombinedShipmentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderCombinedShipmentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order/combined/shipments"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    OrderCombinedShipmentsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order/combined/shipments"),
            headers: params.headers,
            method: 'POST',
        });
    };
    OrderCombinedShipmentsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order/combined/shipments/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrderCombinedShipmentsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order/combined/shipments/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrderCombinedShipmentsResource;
}($Resource));
export { OrderCombinedShipmentsResource };
var OrderDetailsResource = /** @class */ (function (_super) {
    __extends(OrderDetailsResource, _super);
    function OrderDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns order information*/
    OrderDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    /*Returns order information for a specific number*/
    OrderDetailsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns all notes for the order*/
    OrderDetailsResource.prototype.getNotesByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number), "/notes"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create an order note for the order*/
    OrderDetailsResource.prototype.postNotesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number), "/notes"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns an order note for the order given an ID*/
    OrderDetailsResource.prototype.getNotesByNumberAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number), "/notes/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an order note for the order given an ID*/
    OrderDetailsResource.prototype.putNotesByNumberAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number), "/notes/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete an order note from the order*/
    OrderDetailsResource.prototype.deleteNotesByNumberAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order-details/").concat(encodeURIComponent(params.number), "/notes/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrderDetailsResource;
}($Resource));
export { OrderDetailsResource };
var OrderPaymentAuthorizationsResource = /** @class */ (function (_super) {
    __extends(OrderPaymentAuthorizationsResource, _super);
    function OrderPaymentAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Create a new authorization for this order.*/
    OrderPaymentAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/order/payments/authorization"),
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    return OrderPaymentAuthorizationsResource;
}($Resource));
export { OrderPaymentAuthorizationsResource };
var OrderRevenueRegionChartsResource = /** @class */ (function (_super) {
    __extends(OrderRevenueRegionChartsResource, _super);
    function OrderRevenueRegionChartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderRevenueRegionChartsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/reports/revenue/regions"),
            headers: params.headers,
            method: 'GET',
            query: {
                after: params.after,
                before: params.before,
                on_or_after: params.on_or_after,
                on_or_before: params.on_or_before,
                regions: params.regions,
                timezone: params.timezone,
            },
        });
    };
    return OrderRevenueRegionChartsResource;
}($Resource));
export { OrderRevenueRegionChartsResource };
var OrderRevenueTimelineChartsResource = /** @class */ (function (_super) {
    __extends(OrderRevenueTimelineChartsResource, _super);
    function OrderRevenueTimelineChartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderRevenueTimelineChartsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/reports/revenue/timeline"),
            headers: params.headers,
            method: 'GET',
            query: {
                after: params.after,
                before: params.before,
                interval: params.interval,
                on_or_after: params.on_or_after,
                on_or_before: params.on_or_before,
                region: params.region,
                timezone: params.timezone,
            },
        });
    };
    return OrderRevenueTimelineChartsResource;
}($Resource));
export { OrderRevenueTimelineChartsResource };
var OrganizationAccountsResource = /** @class */ (function (_super) {
    __extends(OrganizationAccountsResource, _super);
    function OrganizationAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    OrganizationAccountsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationAccountsResource.prototype.getContactsByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    OrganizationAccountsResource.prototype.postContactsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/contacts"),
            headers: params.headers,
            method: 'POST',
        });
    };
    OrganizationAccountsResource.prototype.getContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationAccountsResource.prototype.deleteContactsByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/contacts/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    OrganizationAccountsResource.prototype.getStatisticsByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/statistics"),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationAccountsResource.prototype.getTransactionsByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/accounts/").concat(encodeURIComponent(params.key), "/transactions"),
            headers: params.headers,
            method: 'GET',
            query: {
                created_after: params.created_after,
                created_before: params.created_before,
                created_from: params.created_from,
                created_on_or_after: params.created_on_or_after,
                created_on_or_before: params.created_on_or_before,
                created_to: params.created_to,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                posted_after: params.posted_after,
                posted_before: params.posted_before,
                posted_from: params.posted_from,
                posted_on_or_after: params.posted_on_or_after,
                posted_on_or_before: params.posted_on_or_before,
                posted_to: params.posted_to,
                sort: params.sort,
                statement: params.statement,
                status: params.status,
                type: params.type,
            },
        });
    };
    return OrganizationAccountsResource;
}($Resource));
export { OrganizationAccountsResource };
var OrganizationBillingStatementsResource = /** @class */ (function (_super) {
    __extends(OrganizationBillingStatementsResource, _super);
    function OrganizationBillingStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationBillingStatementsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/account/statements"),
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    OrganizationBillingStatementsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationBillingStatementsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/account/statements/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Generates and sends an email about this statement*/
    OrganizationBillingStatementsResource.prototype.postEmailById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/account/statements/").concat(encodeURIComponent(params.id), "/email"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationBillingStatementsResource;
}($Resource));
export { OrganizationBillingStatementsResource };
var OrganizationCurrencySettingsResource = /** @class */ (function (_super) {
    __extends(OrganizationCurrencySettingsResource, _super);
    function OrganizationCurrencySettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search currency settings. Always paginated.*/
    OrganizationCurrencySettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/settings',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Create currency settings.*/
    OrganizationCurrencySettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/currency/settings',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get currency settings.*/
    OrganizationCurrencySettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing currency settings.*/
    OrganizationCurrencySettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrganizationCurrencySettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/currency/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrganizationCurrencySettingsResource;
}($Resource));
export { OrganizationCurrencySettingsResource };
var OrganizationDeactivationsResource = /** @class */ (function (_super) {
    __extends(OrganizationDeactivationsResource, _super);
    function OrganizationDeactivationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationDeactivationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/deactivation"),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationDeactivationsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/deactivation"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrganizationDeactivationsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/deactivation"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrganizationDeactivationsResource;
}($Resource));
export { OrganizationDeactivationsResource };
var OrganizationDebugTransactionsResource = /** @class */ (function (_super) {
    __extends(OrganizationDebugTransactionsResource, _super);
    function OrganizationDebugTransactionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationDebugTransactionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/debug/transactions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationDebugTransactionsResource;
}($Resource));
export { OrganizationDebugTransactionsResource };
var OrganizationMembershipCopiesResource = /** @class */ (function (_super) {
    __extends(OrganizationMembershipCopiesResource, _super);
    function OrganizationMembershipCopiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationMembershipCopiesResource.prototype.postMembershipAndCopies = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/organization/membership/copies',
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationMembershipCopiesResource;
}($Resource));
export { OrganizationMembershipCopiesResource };
var OrganizationOnboardingStateAuditResultsResource = /** @class */ (function (_super) {
    __extends(OrganizationOnboardingStateAuditResultsResource, _super);
    function OrganizationOnboardingStateAuditResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationOnboardingStateAuditResultsResource.prototype.getAudit = function (params) {
        return this.client.request({
            endpoint: '/internal/onboarding/state/audit',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return OrganizationOnboardingStateAuditResultsResource;
}($Resource));
export { OrganizationOnboardingStateAuditResultsResource };
var OrganizationPaymentSettingsResource = /** @class */ (function (_super) {
    __extends(OrganizationPaymentSettingsResource, _super);
    function OrganizationPaymentSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves payment settings for a given organization.*/
    OrganizationPaymentSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/payment/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates payment settings for an existing organization.*/
    OrganizationPaymentSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/payment/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Provides visibility into recent changes of payment settings.*/
    OrganizationPaymentSettingsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/payment/settings/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return OrganizationPaymentSettingsResource;
}($Resource));
export { OrganizationPaymentSettingsResource };
var OrganizationRestrictionStatusesResource = /** @class */ (function (_super) {
    __extends(OrganizationRestrictionStatusesResource, _super);
    function OrganizationRestrictionStatusesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get the current status of organization restriction review, ready/not-ready with its reason*/
    OrganizationRestrictionStatusesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/restriction/".concat(encodeURIComponent(params.organization), "/status"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*reset screening progress for an org back to un-screened status, as if new*/
    OrganizationRestrictionStatusesResource.prototype.postReset = function (params) {
        return this.client.request({
            endpoint: "/internal/restriction/".concat(encodeURIComponent(params.organization), "/status/reset"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationRestrictionStatusesResource;
}($Resource));
export { OrganizationRestrictionStatusesResource };
var OrganizationRestrictionStatusNotesResource = /** @class */ (function (_super) {
    __extends(OrganizationRestrictionStatusNotesResource, _super);
    function OrganizationRestrictionStatusNotesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*return all the notes for a given organization*/
    OrganizationRestrictionStatusNotesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/restriction/".concat(encodeURIComponent(params.organization), "/status/notes"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*record a new organization restriction screening status note*/
    OrganizationRestrictionStatusNotesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/restriction/".concat(encodeURIComponent(params.organization), "/status/notes"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*update an organization restriction screening status note*/
    OrganizationRestrictionStatusNotesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/restriction/".concat(encodeURIComponent(params.organization), "/status/notes/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrganizationRestrictionStatusNotesResource;
}($Resource));
export { OrganizationRestrictionStatusNotesResource };
var OrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(OrganizationSettingsResource, _super);
    function OrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experience/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/experience/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrganizationSettingsResource;
}($Resource));
export { OrganizationSettingsResource };
var OrganizationsAuditCheckReportsResource = /** @class */ (function (_super) {
    __extends(OrganizationsAuditCheckReportsResource, _super);
    function OrganizationsAuditCheckReportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationsAuditCheckReportsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/organizations/audit/check/report',
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                limit: params.limit,
                offset: params.offset,
                onboarding_state: params.onboarding_state,
                organization_status: params.organization_status,
            },
        });
    };
    return OrganizationsAuditCheckReportsResource;
}($Resource));
export { OrganizationsAuditCheckReportsResource };
var PartnersResource = /** @class */ (function (_super) {
    __extends(PartnersResource, _super);
    function PartnersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/partners',
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/partners/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnersResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/partners/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnersResource;
}($Resource));
export { PartnersResource };
var PartnerAuthorizationsResource = /** @class */ (function (_super) {
    __extends(PartnerAuthorizationsResource, _super);
    function PartnerAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*For the authorized user, if the specified partner exists, and the user is an active member of this partner, returns the authorization data used throughout APIs at Flow, including the user's role in that organization and the partner environment. Otherwise, returns 401 - this indicates either the org does not exist or the user does not have access to the partner.*/
    PartnerAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/partner-authorizations',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*For the authorized user and specific partner, if the user is an active member of this partner, returns the authorization data used throughout APIs at Flow, including the user's role in that partner and the partner environment.*/
    PartnerAuthorizationsResource.prototype.getByPartner = function (params) {
        return this.client.request({
            endpoint: "/partner-authorizations/".concat(encodeURIComponent(params.partner)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return PartnerAuthorizationsResource;
}($Resource));
export { PartnerAuthorizationsResource };
var PartnerMembershipsResource = /** @class */ (function (_super) {
    __extends(PartnerMembershipsResource, _super);
    function PartnerMembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerMembershipsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships"),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                role: params.role,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    PartnerMembershipsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships"),
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnerMembershipsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                membership: params.membership,
                offset: params.offset,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    PartnerMembershipsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnerMembershipsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    PartnerMembershipsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/partners/".concat(encodeURIComponent(params.partner), "/memberships/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnerMembershipsResource;
}($Resource));
export { PartnerMembershipsResource };
var PartnerOrganizationAuthorizationsResource = /** @class */ (function (_super) {
    __extends(PartnerOrganizationAuthorizationsResource, _super);
    function PartnerOrganizationAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerOrganizationAuthorizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner-organization-authorizations"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                partner: params.partner,
                sort: params.sort,
            },
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner-organization-authorizations"),
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner-organization-authorizations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner-organization-authorizations/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnerOrganizationAuthorizationsResource;
}($Resource));
export { PartnerOrganizationAuthorizationsResource };
var PartnerOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(PartnerOrganizationSettingsResource, _super);
    function PartnerOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnerOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/partner/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return PartnerOrganizationSettingsResource;
}($Resource));
export { PartnerOrganizationSettingsResource };
var PassphrasesResource = /** @class */ (function (_super) {
    __extends(PassphrasesResource, _super);
    function PassphrasesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PassphrasesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/passphrases"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                tribe: params.tribe,
            },
        });
    };
    /*Creates a new passphrase for a given tribe.*/
    PassphrasesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/passphrases"),
            headers: params.headers,
            method: 'POST',
        });
    };
    PassphrasesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/passphrases/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Used to provide the cleartext password for a given passphrase.*/
    PassphrasesResource.prototype.postAuthenticationsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/passphrases/").concat(encodeURIComponent(params.id), "/authentications"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return PassphrasesResource;
}($Resource));
export { PassphrasesResource };
var PaymentMethodDetailsResource = /** @class */ (function (_super) {
    __extends(PaymentMethodDetailsResource, _super);
    function PaymentMethodDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/payment/method/details',
            headers: params.headers,
            method: 'GET',
            query: {
                environment: params.environment,
                method_types: params.method_types,
            },
        });
    };
    return PaymentMethodDetailsResource;
}($Resource));
export { PaymentMethodDetailsResource };
var PaymentOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(PaymentOrganizationSettingsResource, _super);
    function PaymentOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves payment settings for a given organization.*/
    PaymentOrganizationSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/organization/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates payment settings for an existing organization.*/
    PaymentOrganizationSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/organization/settings/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return PaymentOrganizationSettingsResource;
}($Resource));
export { PaymentOrganizationSettingsResource };
var PaymentRedirectsResource = /** @class */ (function (_super) {
    __extends(PaymentRedirectsResource, _super);
    function PaymentRedirectsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Redirects to the appropriate success or failure URL corresponding with the given authorization, if it exists.*/
    PaymentRedirectsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/payment/redirects/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
            query: {
                authResult: params.authResult,
                merchantReference: params.merchantReference,
                merchantSig: params.merchantSig,
                paymentMethod: params.paymentMethod,
                pspReference: params.pspReference,
                shopperLocale: params.shopperLocale,
                skinCode: params.skinCode,
            },
        });
    };
    /*Redirects to the appropriate success or failure URL corresponding with the given authorization, if it exists. A POST endpoint is required for 3D Secure through Adyen.*/
    PaymentRedirectsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/payment/redirects/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'POST',
        });
    };
    return PaymentRedirectsResource;
}($Resource));
export { PaymentRedirectsResource };
var PendingBankPaymentsResource = /** @class */ (function (_super) {
    __extends(PendingBankPaymentsResource, _super);
    function PendingBankPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PendingBankPaymentsResource.prototype.getPending = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/bank/payment/pending',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                source_id: params.source_id,
                source_type: params.source_type,
            },
        });
    };
    return PendingBankPaymentsResource;
}($Resource));
export { PendingBankPaymentsResource };
var PlatformFeeChangesResource = /** @class */ (function (_super) {
    __extends(PlatformFeeChangesResource, _super);
    function PlatformFeeChangesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlatformFeeChangesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/platform_fee_changes"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    PlatformFeeChangesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/platform_fee_changes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    PlatformFeeChangesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/platform_fee_changes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    PlatformFeeChangesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/platform_fee_changes/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PlatformFeeChangesResource;
}($Resource));
export { PlatformFeeChangesResource };
var ProcessorAccountsResource = /** @class */ (function (_super) {
    __extends(ProcessorAccountsResource, _super);
    function ProcessorAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all onboarded accounts for a given payment processor. This is most useful for processors like Adyen, Fiserv, and Stripe that have platform level accounts.*/
    ProcessorAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts"),
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                owner: params.owner,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Retrieves details about an account with a processor.*/
    ProcessorAccountsResource.prototype.getByOrganizationAndKey = function (params) {
        return this.client.request({
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.organization), "/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates an existing account for a given payment processor on to Flow.*/
    ProcessorAccountsResource.prototype.putByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.organization), "/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates the status of an existing account for a given payment processor on to Flow.*/
    ProcessorAccountsResource.prototype.putModificationsByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.organization), "/").concat(encodeURIComponent(params.key), "/modifications"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates details about a payment processor account.*/
    ProcessorAccountsResource.prototype.putModificationsAndStatusByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.organization), "/").concat(encodeURIComponent(params.key), "/modifications/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ProcessorAccountsResource;
}($Resource));
export { ProcessorAccountsResource };
var ProcessorMerchantsResource = /** @class */ (function (_super) {
    __extends(ProcessorMerchantsResource, _super);
    function ProcessorMerchantsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all onboarded merchants under a given payment processor account.*/
    ProcessorMerchantsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants"),
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                external_id: params.external_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Creates a new merchant under an existing payment processor account and onboards it to Flow. Currently not functional for any processor.*/
    ProcessorMerchantsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Retrieves details about an onboarded merchant under an onboarded payment procesor account.*/
    ProcessorMerchantsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates an existing merchant under an existing payment processor account.*/
    ProcessorMerchantsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates details about a merchant under a payment processor account.*/
    ProcessorMerchantsResource.prototype.putModificationsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants/").concat(encodeURIComponent(params.key), "/modifications"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates an existing merchant's status.*/
    ProcessorMerchantsResource.prototype.putModificationsAndStatusByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/".concat(encodeURIComponent(params.processor), "/accounts/").concat(encodeURIComponent(params.account_organization), "/").concat(encodeURIComponent(params.account_key), "/merchants/").concat(encodeURIComponent(params.key), "/modifications/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ProcessorMerchantsResource;
}($Resource));
export { ProcessorMerchantsResource };
var ProductClassificationsResource = /** @class */ (function (_super) {
    __extends(ProductClassificationsResource, _super);
    function ProductClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductClassificationsResource.prototype.postHarmonizeLabels = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/product_classifications/harmonize_labels',
            headers: params.headers,
            method: 'POST',
        });
    };
    ProductClassificationsResource.prototype.getOrganizationAndProductByOrganizationIdAndProductId = function (params) {
        return this.client.request({
            endpoint: "/product_classifications/organization/".concat(encodeURIComponent(params.organization_id), "/product/").concat(encodeURIComponent(params.product_id)),
            headers: params.headers,
            method: 'GET',
            query: {
                next_product_id_filter_by_organization: params.next_product_id_filter_by_organization,
            },
        });
    };
    ProductClassificationsResource.prototype.postOrganizationAndProductByOrganizationIdAndProductId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/product_classifications/organization/".concat(encodeURIComponent(params.organization_id), "/product/").concat(encodeURIComponent(params.product_id)),
            headers: params.headers,
            method: 'POST',
        });
    };
    ProductClassificationsResource.prototype.getRefreshDefaultHs6 = function (params) {
        return this.client.request({
            endpoint: '/product_classifications/refresh_default_hs6',
            headers: params.headers,
            method: 'GET',
            query: {
                dry_run: params.dry_run,
            },
        });
    };
    return ProductClassificationsResource;
}($Resource));
export { ProductClassificationsResource };
var ProductReviewHistoriesResource = /** @class */ (function (_super) {
    __extends(ProductReviewHistoriesResource, _super);
    function ProductReviewHistoriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns product_review_history for a specific product id.*/
    ProductReviewHistoriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/products/").concat(encodeURIComponent(params.id), "/histories"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ProductReviewHistoriesResource;
}($Resource));
export { ProductReviewHistoriesResource };
var PspRoutingDistributionRevisionsResource = /** @class */ (function (_super) {
    __extends(PspRoutingDistributionRevisionsResource, _super);
    function PspRoutingDistributionRevisionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get the current revision of psp_routing_distributions*/
    PspRoutingDistributionRevisionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/psp_routing_distribution_revisions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Update the current psp_routing_distributions by creating a new revision*/
    PspRoutingDistributionRevisionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/psp_routing_distribution_revisions',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get the current revision of psp_routing_distributions*/
    PspRoutingDistributionRevisionsResource.prototype.getCurrent = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/psp_routing_distribution_revisions/current',
            headers: params.headers,
            method: 'GET',
        });
    };
    return PspRoutingDistributionRevisionsResource;
}($Resource));
export { PspRoutingDistributionRevisionsResource };
var PublicHubsResource = /** @class */ (function (_super) {
    __extends(PublicHubsResource, _super);
    function PublicHubsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicHubsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/public_hub',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    PublicHubsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/public_hub',
            headers: params.headers,
            method: 'POST',
        });
    };
    PublicHubsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/public_hub/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    PublicHubsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/public_hub/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    PublicHubsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/public_hub/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PublicHubsResource;
}($Resource));
export { PublicHubsResource };
var RateAndRuleLookupsResource = /** @class */ (function (_super) {
    __extends(RateAndRuleLookupsResource, _super);
    function RateAndRuleLookupsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RateAndRuleLookupsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/levy/rates"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return RateAndRuleLookupsResource;
}($Resource));
export { RateAndRuleLookupsResource };
var RateLevelsResource = /** @class */ (function (_super) {
    __extends(RateLevelsResource, _super);
    function RateLevelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RateLevelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/rate_levels',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
            },
        });
    };
    RateLevelsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/rate_levels',
            headers: params.headers,
            method: 'POST',
        });
    };
    RateLevelsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    RateLevelsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RateLevelsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RateLevelsResource;
}($Resource));
export { RateLevelsResource };
var RateLevelOrganizationsResource = /** @class */ (function (_super) {
    __extends(RateLevelOrganizationsResource, _super);
    function RateLevelOrganizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RateLevelOrganizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization_id), "/rate_levels"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    RateLevelOrganizationsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization_id), "/rate_levels"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RateLevelOrganizationsResource.prototype.deleteByRateLevelId = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization_id), "/rate_levels/").concat(encodeURIComponent(params.rate_level_id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RateLevelOrganizationsResource;
}($Resource));
export { RateLevelOrganizationsResource };
var RateLevelRatecardsResource = /** @class */ (function (_super) {
    __extends(RateLevelRatecardsResource, _super);
    function RateLevelRatecardsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RateLevelRatecardsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.rate_level_id), "/ratecards"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    RateLevelRatecardsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.rate_level_id), "/ratecards"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RateLevelRatecardsResource.prototype.deleteByRatecardId = function (params) {
        return this.client.request({
            endpoint: "/internal/rate_levels/".concat(encodeURIComponent(params.rate_level_id), "/ratecards/").concat(encodeURIComponent(params.ratecard_id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RateLevelRatecardsResource;
}($Resource));
export { RateLevelRatecardsResource };
var RatecardServiceFeesOverridesResource = /** @class */ (function (_super) {
    __extends(RatecardServiceFeesOverridesResource, _super);
    function RatecardServiceFeesOverridesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardServiceFeesOverridesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/ratecard/".concat(encodeURIComponent(params.ratecard_id), "/service/fees/override"),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardServiceFeesOverridesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/ratecard/".concat(encodeURIComponent(params.ratecard_id), "/service/fees/override"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RatecardServiceFeesOverridesResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/internal/ratecard/".concat(encodeURIComponent(params.ratecard_id), "/service/fees/override"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RatecardServiceFeesOverridesResource;
}($Resource));
export { RatecardServiceFeesOverridesResource };
var RatecardStandardConfigurationsResource = /** @class */ (function (_super) {
    __extends(RatecardStandardConfigurationsResource, _super);
    function RatecardStandardConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardStandardConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/ratecard/standard/configurations"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                source_ratecard_number: params.source_ratecard_number,
                source_ratecard_organization: params.source_ratecard_organization,
            },
        });
    };
    RatecardStandardConfigurationsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/ratecard/standard/configurations/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardStandardConfigurationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/ratecard/standard/configurations/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RatecardStandardConfigurationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/ratecard/standard/configurations/").concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RatecardStandardConfigurationsResource;
}($Resource));
export { RatecardStandardConfigurationsResource };
var RatesNamesSummariesResource = /** @class */ (function (_super) {
    __extends(RatesNamesSummariesResource, _super);
    function RatesNamesSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a summary of the rate names that apply.*/
    RatesNamesSummariesResource.prototype.getDestinationAndOriginByDestinationAndOrigin = function (params) {
        return this.client.request({
            endpoint: "/harmonization/rates/names/summaries/destination/".concat(encodeURIComponent(params.destination), "/origin/").concat(encodeURIComponent(params.origin)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RatesNamesSummariesResource;
}($Resource));
export { RatesNamesSummariesResource };
var ReboundConfigurationsResource = /** @class */ (function (_super) {
    __extends(ReboundConfigurationsResource, _super);
    function ReboundConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReboundConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/rebound/configuration"),
            headers: params.headers,
            method: 'GET',
        });
    };
    ReboundConfigurationsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/rebound/configuration"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ReboundConfigurationsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/rebound/configuration"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ReboundConfigurationsResource;
}($Resource));
export { ReboundConfigurationsResource };
var ReportsResource = /** @class */ (function (_super) {
    __extends(ReportsResource, _super);
    function ReportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/report',
            headers: params.headers,
            method: 'POST',
        });
    };
    ReportsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/report/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ReportsResource;
}($Resource));
export { ReportsResource };
var ReportSummaryResource = /** @class */ (function (_super) {
    __extends(ReportSummaryResource, _super);
    function ReportSummaryResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportSummaryResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/reports/summary',
            headers: params.headers,
            method: 'GET',
            query: {
                date_from: params.date_from,
                date_to: params.date_to,
                email: params.email,
                limit: params.limit,
                organization_id: params.organization_id,
                product_id: params.product_id,
            },
        });
    };
    return ReportSummaryResource;
}($Resource));
export { ReportSummaryResource };
var RescreenRestrictionsProductsResource = /** @class */ (function (_super) {
    __extends(RescreenRestrictionsProductsResource, _super);
    function RescreenRestrictionsProductsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Trigger rescreening for all product restrictions in an organization*/
    RescreenRestrictionsProductsResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/rescreen"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return RescreenRestrictionsProductsResource;
}($Resource));
export { RescreenRestrictionsProductsResource };
var RestrictionCategoriesResource = /** @class */ (function (_super) {
    __extends(RestrictionCategoriesResource, _super);
    function RestrictionCategoriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns categories*/
    RestrictionCategoriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/categories"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return RestrictionCategoriesResource;
}($Resource));
export { RestrictionCategoriesResource };
var RestrictionFiltersResource = /** @class */ (function (_super) {
    __extends(RestrictionFiltersResource, _super);
    function RestrictionFiltersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns all valid filters (categories, keywords) for a given organization and all restrictions in system*/
    RestrictionFiltersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/filters"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    /*Returns all valid filters (categories, keywords, updated by users) for a given organization and all restrictions in system*/
    RestrictionFiltersResource.prototype.getCatalog = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/filters/catalog"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    /*Returns all valid filters (categories, keywords, restrictions) for a given organization*/
    RestrictionFiltersResource.prototype.getPendingReviews = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/filters/pending_reviews"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return RestrictionFiltersResource;
}($Resource));
export { RestrictionFiltersResource };
var RestrictionItemsResource = /** @class */ (function (_super) {
    __extends(RestrictionItemsResource, _super);
    function RestrictionItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of item restriction decisions for an organization*/
    RestrictionItemsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/items"),
            headers: params.headers,
            method: 'GET',
            query: {
                categories: params.categories,
                limit: params.limit,
                negative_keywords: params.negative_keywords,
                offset: params.offset,
                positive_keywords: params.positive_keywords,
                product_id: params.product_id,
                product_name_query: params.product_name_query,
                rule_ids: params.rule_ids,
                sort: params.sort,
                status: params.status,
                statuses: params.statuses,
                user_ids: params.user_ids,
            },
        });
    };
    /*Returns a list of item restriction decisions for an organization*/
    RestrictionItemsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/items"),
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns a restriction product item by id*/
    RestrictionItemsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/items/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RestrictionItemsResource;
}($Resource));
export { RestrictionItemsResource };
var RestrictionOrganizationsResource = /** @class */ (function (_super) {
    __extends(RestrictionOrganizationsResource, _super);
    function RestrictionOrganizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*return the organization status for a given organization*/
    RestrictionOrganizationsResource.prototype.getRestrictionAndStatusByOrganization = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/status"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*accept/create the organization restriction status for a given organization*/
    RestrictionOrganizationsResource.prototype.postRestrictionAndStatusByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/status"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*update the organization restriction status for a given organization*/
    RestrictionOrganizationsResource.prototype.putRestrictionAndStatusByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/status"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Returns organizations onboarded into the restrictions platform*/
    RestrictionOrganizationsResource.prototype.getSearchAndRestrictionAndOrganizations = function (params) {
        return this.client.request({
            endpoint: '/jailhouse/search/restriction/organizations',
            headers: params.headers,
            method: 'GET',
            query: {
                environment: params.environment,
                ids: params.ids,
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    return RestrictionOrganizationsResource;
}($Resource));
export { RestrictionOrganizationsResource };
var RestrictionOrganizationDecisionSummariesResource = /** @class */ (function (_super) {
    __extends(RestrictionOrganizationDecisionSummariesResource, _super);
    function RestrictionOrganizationDecisionSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns summaries about restriction decisions for items*/
    RestrictionOrganizationDecisionSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/jailhouse/restriction/organization/decision/summaries',
            headers: params.headers,
            method: 'GET',
            query: {
                approval_status: params.approval_status,
                earliest_pending_date_after: params.earliest_pending_date_after,
                earliest_pending_date_before: params.earliest_pending_date_before,
                environment: params.environment,
                filter_orgs_with_pending_verifications: params.filter_orgs_with_pending_verifications,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                review_type: params.review_type,
                rule_ids: params.rule_ids,
                screening_status: params.screening_status,
                sort: params.sort,
                transacting_orgs: params.transacting_orgs,
            },
        });
    };
    return RestrictionOrganizationDecisionSummariesResource;
}($Resource));
export { RestrictionOrganizationDecisionSummariesResource };
var RestrictionProductsResource = /** @class */ (function (_super) {
    __extends(RestrictionProductsResource, _super);
    function RestrictionProductsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of products and their restriction information for an organization*/
    RestrictionProductsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/products"),
            headers: params.headers,
            method: 'GET',
            query: {
                accepted_rules: params.accepted_rules,
                categories: params.categories,
                limit: params.limit,
                negative_keywords: params.negative_keywords,
                offset: params.offset,
                positive_keywords: params.positive_keywords,
                product_id: params.product_id,
                product_name_query: params.product_name_query,
                restricted_rules: params.restricted_rules,
                sort: params.sort,
                user_ids: params.user_ids,
            },
        });
    };
    /*Returns a list of products and their restriction information for an organization*/
    RestrictionProductsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/products"),
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Bulk Inserts/Updates of restriction decisions*/
    RestrictionProductsResource.prototype.postDecisions = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/products/decisions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns a product by id*/
    RestrictionProductsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/products/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RestrictionProductsResource;
}($Resource));
export { RestrictionProductsResource };
var RestrictionProductSummariesResource = /** @class */ (function (_super) {
    __extends(RestrictionProductSummariesResource, _super);
    function RestrictionProductSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get the restriction rule decisions applied to a product*/
    RestrictionProductSummariesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/restriction/".concat(encodeURIComponent(params.organization), "/product/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RestrictionProductSummariesResource;
}($Resource));
export { RestrictionProductSummariesResource };
var RestrictionRulesResource = /** @class */ (function (_super) {
    __extends(RestrictionRulesResource, _super);
    function RestrictionRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestrictionRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/jailhouse/restriction/rules',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    RestrictionRulesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/rules/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the list of restriction rules currently applicable for an organization*/
    RestrictionRulesResource.prototype.getByOrganizationAndStatus = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/rules/".concat(encodeURIComponent(params.organization), "/").concat(encodeURIComponent(params.status)),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    RestrictionRulesResource.prototype.postInternalAndRestrictionAndRules = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/restriction/rules',
            headers: params.headers,
            method: 'POST',
        });
    };
    RestrictionRulesResource.prototype.putInternalAndRestrictionAndRulesById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/restriction/rules/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return RestrictionRulesResource;
}($Resource));
export { RestrictionRulesResource };
var RestrictionRuleOverridesResource = /** @class */ (function (_super) {
    __extends(RestrictionRuleOverridesResource, _super);
    function RestrictionRuleOverridesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestrictionRuleOverridesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/jailhouse/restriction/rule_overrides',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    RestrictionRuleOverridesResource.prototype.getByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/rule_overrides/".concat(encodeURIComponent(params.organization_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RestrictionRuleOverridesResource;
}($Resource));
export { RestrictionRuleOverridesResource };
var RoutingEntitiesResource = /** @class */ (function (_super) {
    __extends(RoutingEntitiesResource, _super);
    function RoutingEntitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all potential payment routing options based on the provided parameters. This will exclude top level accounts that cannot process transactions without a valid merchant - they would be included if any of their merchants are eligible. All querystrings will be processed at the lowest available level for a given processor.*/
    RoutingEntitiesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/routing/entities',
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                owner: params.owner,
                processor: params.processor,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return RoutingEntitiesResource;
}($Resource));
export { RoutingEntitiesResource };
var SandboxSetupsResource = /** @class */ (function (_super) {
    __extends(SandboxSetupsResource, _super);
    function SandboxSetupsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SandboxSetupsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/merchant/config/sandbox/setup"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SandboxSetupsResource;
}($Resource));
export { SandboxSetupsResource };
var ScreensResource = /** @class */ (function (_super) {
    __extends(ScreensResource, _super);
    function ScreensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides a list of screens given a query 'q' and optional countries parameter to search on a specified list of countries.*/
    ScreensResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/screens/".concat(encodeURIComponent(params.key)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ScreensResource;
}($Resource));
export { ScreensResource };
var SearchProviderExportsResource = /** @class */ (function (_super) {
    __extends(SearchProviderExportsResource, _super);
    function SearchProviderExportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchProviderExportsResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/search_provider_export"),
            headers: params.headers,
            method: 'POST',
        });
    };
    SearchProviderExportsResource.prototype.postExperienceByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/search_provider_export/experience/").concat(encodeURIComponent(params.experience_key)),
            headers: params.headers,
            method: 'POST',
        });
    };
    return SearchProviderExportsResource;
}($Resource));
export { SearchProviderExportsResource };
var SessionCountriesResource = /** @class */ (function (_super) {
    __extends(SessionCountriesResource, _super);
    function SessionCountriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionCountriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/session/countries"),
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionCountriesResource.prototype.putByCountry = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/session/countries/").concat(encodeURIComponent(params.country)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SessionCountriesResource;
}($Resource));
export { SessionCountriesResource };
var SessionOrderDataResource = /** @class */ (function (_super) {
    __extends(SessionOrderDataResource, _super);
    function SessionOrderDataResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionOrderDataResource.prototype.getBySessionId = function (params) {
        return this.client.request({
            endpoint: "/session/order/data/".concat(encodeURIComponent(params.session_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return SessionOrderDataResource;
}($Resource));
export { SessionOrderDataResource };
var SessionRolloutsResource = /** @class */ (function (_super) {
    __extends(SessionRolloutsResource, _super);
    function SessionRolloutsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionRolloutsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/session/rollout"),
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionRolloutsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/session/rollout"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SessionRolloutsResource;
}($Resource));
export { SessionRolloutsResource };
var ShippingLanesResource = /** @class */ (function (_super) {
    __extends(ShippingLanesResource, _super);
    function ShippingLanesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to get shipping lanes for which Flow can act as Merchant of Record.*/
    ShippingLanesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/shopify/markets/shipping/lanes',
            headers: params.headers,
            method: 'GET',
            query: {
                ship_from_country: params.ship_from_country,
            },
        });
    };
    return ShippingLanesResource;
}($Resource));
export { ShippingLanesResource };
var ShopsResource = /** @class */ (function (_super) {
    __extends(ShopsResource, _super);
    function ShopsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopsResource.prototype.getRedirectsAndOrderByApp = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/redirects/".concat(encodeURIComponent(params.app), "/order"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                shop: params.shop,
            },
        });
    };
    ShopsResource.prototype.getByMyshopifyDomain = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/".concat(encodeURIComponent(params.myshopify_domain)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopsResource.prototype.putByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/".concat(encodeURIComponent(params.myshopify_domain)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopsResource.prototype.deleteByMyshopifyDomain = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/".concat(encodeURIComponent(params.myshopify_domain)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ShopsResource.prototype.postInstallByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/".concat(encodeURIComponent(params.myshopify_domain), "/install"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopsResource.prototype.postSessionsByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/".concat(encodeURIComponent(params.myshopify_domain), "/sessions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopsResource;
}($Resource));
export { ShopsResource };
var ShopifyGiftCardBalancesResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardBalancesResource, _super);
    function ShopifyGiftCardBalancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check the remaining balance on a Shopify gift card*/
    ShopifyGiftCardBalancesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/gift/cards/balances"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardBalancesResource;
}($Resource));
export { ShopifyGiftCardBalancesResource };
var ShopifyGiftCardRedemptionsResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardRedemptionsResource, _super);
    function ShopifyGiftCardRedemptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Redeems a Shopify gift card*/
    ShopifyGiftCardRedemptionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/gift/cards/redemptions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardRedemptionsResource;
}($Resource));
export { ShopifyGiftCardRedemptionsResource };
var ShopifyGiftCardReversalsResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardReversalsResource, _super);
    function ShopifyGiftCardReversalsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Reverses a Shopify gift card redemption*/
    ShopifyGiftCardReversalsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/gift/cards/reversals"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardReversalsResource;
}($Resource));
export { ShopifyGiftCardReversalsResource };
var ShopifyGrantsChecksResource = /** @class */ (function (_super) {
    __extends(ShopifyGrantsChecksResource, _super);
    function ShopifyGrantsChecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyGrantsChecksResource.prototype.getCheckHtml = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/shopify/grants/check.html',
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyGrantsChecksResource;
}($Resource));
export { ShopifyGrantsChecksResource };
var ShopifyMarketsOrderVersionWithShopIdsResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsOrderVersionWithShopIdsResource, _super);
    function ShopifyMarketsOrderVersionWithShopIdsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns shopify order information for a specific internal order number*/
    ShopifyMarketsOrderVersionWithShopIdsResource.prototype.getVersionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/markets/orders/").concat(encodeURIComponent(params.number), "/versions"),
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return ShopifyMarketsOrderVersionWithShopIdsResource;
}($Resource));
export { ShopifyMarketsOrderVersionWithShopIdsResource };
var ShopifyMarketsQueuedRecordsResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsQueuedRecordsResource, _super);
    function ShopifyMarketsQueuedRecordsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves a queued record. Always paginated.*/
    ShopifyMarketsQueuedRecordsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/markets/queued/records',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                sort: params.sort,
                type: params.type,
                type_id: params.type_id,
            },
        });
    };
    /*Enable reviewers to re-queue the queued record for current time and do not wait until the next attempt at*/
    ShopifyMarketsQueuedRecordsResource.prototype.putRequeueAndNowById = function (params) {
        return this.client.request({
            endpoint: "/internal/shopify/markets/queued/records/".concat(encodeURIComponent(params.id), "/requeue/now"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ShopifyMarketsQueuedRecordsResource;
}($Resource));
export { ShopifyMarketsQueuedRecordsResource };
var ShopifyMarketsShopsResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsShopsResource, _super);
    function ShopifyMarketsShopsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to list all the shops currently supported. Always paginated.*/
    ShopifyMarketsShopsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/markets/shops',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Endpoint to get a single shop by organization*/
    ShopifyMarketsShopsResource.prototype.getByOrganization = function (params) {
        return this.client.request({
            endpoint: "/internal/shopify/markets/shops/".concat(encodeURIComponent(params.organization)),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Endpoint to update credentials for a given shop.*/
    ShopifyMarketsShopsResource.prototype.putByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/shopify/markets/shops/".concat(encodeURIComponent(params.organization)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Endpoint to delete a single shop by organization*/
    ShopifyMarketsShopsResource.prototype.deleteByOrganization = function (params) {
        return this.client.request({
            endpoint: "/internal/shopify/markets/shops/".concat(encodeURIComponent(params.organization)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyMarketsShopsResource;
}($Resource));
export { ShopifyMarketsShopsResource };
var ShopifyMarketsShopSummariesResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsShopSummariesResource, _super);
    function ShopifyMarketsShopSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to get an organizationId for a given Shopify Shop id.*/
    ShopifyMarketsShopSummariesResource.prototype.getSummaryByShopifyShopId = function (params) {
        return this.client.request({
            endpoint: "/internal/shopify/markets/shopify/shops/".concat(encodeURIComponent(params.shopify_shop_id), "/summary"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyMarketsShopSummariesResource;
}($Resource));
export { ShopifyMarketsShopSummariesResource };
var ShopifyMarketsSyncsResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsSyncsResource, _super);
    function ShopifyMarketsSyncsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to synchronize all Shopify Country Catalogs for an organization between our system and Shopify. This endpoint will create a Country Catalog for each country that doesn't already exist in Shopify; and pull down and persist all Country Catalogs that exist in Shopify's system, but not ours.*/
    ShopifyMarketsSyncsResource.prototype.postCatalogs = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/sync/catalogs"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyMarketsSyncsResource;
}($Resource));
export { ShopifyMarketsSyncsResource };
var ShopifyMarketsWebhookRegistrationsResource = /** @class */ (function (_super) {
    __extends(ShopifyMarketsWebhookRegistrationsResource, _super);
    function ShopifyMarketsWebhookRegistrationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyMarketsWebhookRegistrationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/".concat(encodeURIComponent(params.organization), "/shopify/markets/webhook/registrations"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyMarketsWebhookRegistrationsResource;
}($Resource));
export { ShopifyMarketsWebhookRegistrationsResource };
var ShopifyMonitoringOrderMonitorsResource = /** @class */ (function (_super) {
    __extends(ShopifyMonitoringOrderMonitorsResource, _super);
    function ShopifyMonitoringOrderMonitorsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyMonitoringOrderMonitorsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/monitoring/order/monitors',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    return ShopifyMonitoringOrderMonitorsResource;
}($Resource));
export { ShopifyMonitoringOrderMonitorsResource };
var ShopifyMonitoringOrderMonitorReviewsResource = /** @class */ (function (_super) {
    __extends(ShopifyMonitoringOrderMonitorReviewsResource, _super);
    function ShopifyMonitoringOrderMonitorReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyMonitoringOrderMonitorReviewsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/shopify/monitoring/order/monitor/reviews',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_monitor_id: params.order_monitor_id,
                organization: params.organization,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    ShopifyMonitoringOrderMonitorReviewsResource.prototype.putStatusByIdAndStatus = function (params) {
        return this.client.request({
            endpoint: "/internal/shopify/monitoring/order/monitor/reviews/".concat(encodeURIComponent(params.id), "/status/").concat(encodeURIComponent(params.status)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ShopifyMonitoringOrderMonitorReviewsResource;
}($Resource));
export { ShopifyMonitoringOrderMonitorReviewsResource };
var ShopifyOrderDetailsResource = /** @class */ (function (_super) {
    __extends(ShopifyOrderDetailsResource, _super);
    function ShopifyOrderDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check inventory for a provided set of items, ensuring expected quantities are in stock.*/
    ShopifyOrderDetailsResource.prototype.postChecksAndInventory = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/checks/inventory"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Endpoint to inject a submitted order directly to shopify, bypassing event processing*/
    ShopifyOrderDetailsResource.prototype.postEnsure = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/ensure"),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Check inventory for order items, ensuring expected quantities are in stock.*/
    ShopifyOrderDetailsResource.prototype.getChecksAndInventoryByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/checks/inventory"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Based on the code, determine if a gift card or promotion is applied to the order.  Attempt will be made to first validate and apply code as a gift card.  If not applicable, attempt to validate and apply the code as a promotion.  This endpoint achieves the same behavior as calling '/payments/gift-card' followed by /promotion.*/
    ShopifyOrderDetailsResource.prototype.postCodesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/codes"),
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    ShopifyOrderDetailsResource.prototype.getContentsByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/contents"),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Apply gift card payment on the order. A gift card can be applied at most once per order.*/
    ShopifyOrderDetailsResource.prototype.postPaymentsAndGiftCardByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/payments/gift-card"),
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Set the promotion code on the cart - shopify only supports up to 1 promotion code. If the cart already had another promotion code, replaces that code with the provided one.*/
    ShopifyOrderDetailsResource.prototype.putPromotionByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/promotion"),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code*/
    ShopifyOrderDetailsResource.prototype.deletePromotionByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/promotion"),
            headers: params.headers,
            method: 'DELETE',
            query: {
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code. Similar to DELETE /:number/promotion but with a different path.*/
    ShopifyOrderDetailsResource.prototype.deletePromotionAndDeleteByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/promotion/delete"),
            headers: params.headers,
            method: 'DELETE',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Clear and apply automatic discounts only on the order. No discount codes are needed.*/
    ShopifyOrderDetailsResource.prototype.putPromotionsAndAutoAndApplyByNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/promotions/auto/apply"),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Returns order authorization details.*/
    ShopifyOrderDetailsResource.prototype.getSubmissionsByNumberAndAuthorizationKey = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/orders/").concat(encodeURIComponent(params.number), "/submissions/").concat(encodeURIComponent(params.authorization_key)),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    return ShopifyOrderDetailsResource;
}($Resource));
export { ShopifyOrderDetailsResource };
var ShopifyOrderFulfillmentsSnapshotsResource = /** @class */ (function (_super) {
    __extends(ShopifyOrderFulfillmentsSnapshotsResource, _super);
    function ShopifyOrderFulfillmentsSnapshotsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Trigger shopify_order_fulfillments data to Athena*/
    ShopifyOrderFulfillmentsSnapshotsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/shopify/monitoring/order-fulfillments/metrics',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyOrderFulfillmentsSnapshotsResource;
}($Resource));
export { ShopifyOrderFulfillmentsSnapshotsResource };
var ShopifyOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(ShopifyOrganizationSettingsResource, _super);
    function ShopifyOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/organization/settings"),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/organization/settings"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/organization/settings"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/organization/settings"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyOrganizationSettingsResource;
}($Resource));
export { ShopifyOrganizationSettingsResource };
var ShopifyPartnerWebhooksResource = /** @class */ (function (_super) {
    __extends(ShopifyPartnerWebhooksResource, _super);
    function ShopifyPartnerWebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyPartnerWebhooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/shopify/partner/webhook',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyPartnerWebhooksResource;
}($Resource));
export { ShopifyPartnerWebhooksResource };
var ShopifyPromotionsResource = /** @class */ (function (_super) {
    __extends(ShopifyPromotionsResource, _super);
    function ShopifyPromotionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyPromotionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/promotions"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    ShopifyPromotionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/promotions"),
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyPromotionsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/promotions/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopifyPromotionsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/promotions/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ShopifyPromotionsResource;
}($Resource));
export { ShopifyPromotionsResource };
var ShopifyStoreDetailsResource = /** @class */ (function (_super) {
    __extends(ShopifyStoreDetailsResource, _super);
    function ShopifyStoreDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns details about the Shopify store*/
    ShopifyStoreDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/jailhouse/restriction/".concat(encodeURIComponent(params.organization), "/shopify_store_detail"),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyStoreDetailsResource;
}($Resource));
export { ShopifyStoreDetailsResource };
var ShopifyWebhookEventsResource = /** @class */ (function (_super) {
    __extends(ShopifyWebhookEventsResource, _super);
    function ShopifyWebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyWebhookEventsResource.prototype.postShopsByShopifyShopIdAndTopicAndAction = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/webhook/events/shops/".concat(encodeURIComponent(params.shopify_shop_id), "/").concat(encodeURIComponent(params.topic), "/").concat(encodeURIComponent(params.action)),
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyWebhookEventsResource.prototype.postByTopicAndAction = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/webhook/events/".concat(encodeURIComponent(params.topic), "/").concat(encodeURIComponent(params.action)),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyWebhookEventsResource;
}($Resource));
export { ShopifyWebhookEventsResource };
var SmpTaxCalculationFormsResource = /** @class */ (function (_super) {
    __extends(SmpTaxCalculationFormsResource, _super);
    function SmpTaxCalculationFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*In some cases, a third party service is used to authorize, record or adjust Flow's estimated tax calculations for Shopify Market Pro orders to ensure compliance. Calling this method when no third party clearance is necessary, or no third party is set up, will result in a 422. A 500x will be issued if a third party is required but is offline, slow or has errors.*/
    SmpTaxCalculationFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/quotes/").concat(encodeURIComponent(params.reference), "/tax/calculation"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return SmpTaxCalculationFormsResource;
}($Resource));
export { SmpTaxCalculationFormsResource };
var SnoozesResource = /** @class */ (function (_super) {
    __extends(SnoozesResource, _super);
    function SnoozesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SnoozesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/snoozes',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                next_action_with: params.next_action_with,
                offset: params.offset,
                sort: params.sort,
                source_type: params.source_type,
            },
        });
    };
    SnoozesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/snoozes',
            headers: params.headers,
            method: 'POST',
        });
    };
    SnoozesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/snoozes/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    SnoozesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/snoozes/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return SnoozesResource;
}($Resource));
export { SnoozesResource };
var SpotRatesResource = /** @class */ (function (_super) {
    __extends(SpotRatesResource, _super);
    function SpotRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search spot rates. Always paginated.*/
    SpotRatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/spot-rates',
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    SpotRatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/spot-rates/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return SpotRatesResource;
}($Resource));
export { SpotRatesResource };
var StoreConnectionsResource = /** @class */ (function (_super) {
    __extends(StoreConnectionsResource, _super);
    function StoreConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreConnectionsResource.prototype.getByDomain = function (params) {
        return this.client.request({
            endpoint: "/magento/stores/".concat(encodeURIComponent(params.domain)),
            headers: params.headers,
            method: 'GET',
        });
    };
    StoreConnectionsResource.prototype.putByDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/magento/stores/".concat(encodeURIComponent(params.domain)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    StoreConnectionsResource.prototype.deleteByDomain = function (params) {
        return this.client.request({
            endpoint: "/magento/stores/".concat(encodeURIComponent(params.domain)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    StoreConnectionsResource.prototype.postInstallByDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/magento/stores/".concat(encodeURIComponent(params.domain), "/install"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return StoreConnectionsResource;
}($Resource));
export { StoreConnectionsResource };
var TariffEligibilitiesResource = /** @class */ (function (_super) {
    __extends(TariffEligibilitiesResource, _super);
    function TariffEligibilitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TariffEligibilitiesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/tariff/eligibilities"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    TariffEligibilitiesResource.prototype.getByType = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/tariff/eligibilities/").concat(encodeURIComponent(params.type)),
            headers: params.headers,
            method: 'GET',
        });
    };
    TariffEligibilitiesResource.prototype.putByType = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/tariff/eligibilities/").concat(encodeURIComponent(params.type)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    TariffEligibilitiesResource.prototype.deleteByType = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/harmonization/tariff/eligibilities/").concat(encodeURIComponent(params.type)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TariffEligibilitiesResource;
}($Resource));
export { TariffEligibilitiesResource };
var TasksResource = /** @class */ (function (_super) {
    __extends(TasksResource, _super);
    function TasksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TasksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/billing/debug/tasks',
            headers: params.headers,
            method: 'GET',
            query: {
                include_errors_only: params.include_errors_only,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    return TasksResource;
}($Resource));
export { TasksResource };
var TaxCalculationFormsResource = /** @class */ (function (_super) {
    __extends(TaxCalculationFormsResource, _super);
    function TaxCalculationFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*In some cases, a third party service is used to authorize, record or adjust Flow's estimated tax calculations to ensure compliance. Calling this method when no third party clearance is necessary, or no third party is set up, will result in a 422. A 500x will be issued if a third party is required but is offline, slow or has errors.*/
    TaxCalculationFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/orders/").concat(encodeURIComponent(params.number), "/tax/calculation"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return TaxCalculationFormsResource;
}($Resource));
export { TaxCalculationFormsResource };
var TechOnboardingDescriptionsResource = /** @class */ (function (_super) {
    __extends(TechOnboardingDescriptionsResource, _super);
    function TechOnboardingDescriptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the description for the given item*/
    TechOnboardingDescriptionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/tech-onboarding/description/".concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
            query: {
                length: params.length,
            },
        });
    };
    return TechOnboardingDescriptionsResource;
}($Resource));
export { TechOnboardingDescriptionsResource };
var TestsResource = /** @class */ (function (_super) {
    __extends(TestsResource, _super);
    function TestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/test"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    TestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/test"),
            headers: params.headers,
            method: 'POST',
        });
    };
    TestsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/test/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    TestsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/test/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    TestsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/test/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TestsResource;
}($Resource));
export { TestsResource };
var TrackingDebugLabelsResource = /** @class */ (function (_super) {
    __extends(TrackingDebugLabelsResource, _super);
    function TrackingDebugLabelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingDebugLabelsResource.prototype.getByLabelId = function (params) {
        return this.client.request({
            endpoint: "/internal/tracking/debug/labels/".concat(encodeURIComponent(params.label_id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    TrackingDebugLabelsResource.prototype.postForceAndTransitByLabelId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/tracking/debug/labels/".concat(encodeURIComponent(params.label_id), "/force/transit"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return TrackingDebugLabelsResource;
}($Resource));
export { TrackingDebugLabelsResource };
var TrackingResyncsResource = /** @class */ (function (_super) {
    __extends(TrackingResyncsResource, _super);
    function TrackingResyncsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingResyncsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/tracking/resync/request',
            headers: params.headers,
            method: 'POST',
        });
    };
    return TrackingResyncsResource;
}($Resource));
export { TrackingResyncsResource };
var TrackingWebhooksResource = /** @class */ (function (_super) {
    __extends(TrackingWebhooksResource, _super);
    function TrackingWebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingWebhooksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/tracking/".concat(encodeURIComponent(params.carrier_id), "/webhook"),
            headers: params.headers,
            method: 'GET',
            query: {
                account_identifier: params.account_identifier,
            },
        });
    };
    TrackingWebhooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/tracking/".concat(encodeURIComponent(params.carrier_id), "/webhook"),
            headers: params.headers,
            method: 'POST',
            query: {
                account_identifier: params.account_identifier,
            },
        });
    };
    return TrackingWebhooksResource;
}($Resource));
export { TrackingWebhooksResource };
var TransactionsResource = /** @class */ (function (_super) {
    __extends(TransactionsResource, _super);
    function TransactionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionsResource.prototype.getOrdersByOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/billing/transactions/orders/").concat(encodeURIComponent(params.order_number)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TransactionsResource;
}($Resource));
export { TransactionsResource };
var TransactionAdjustmentsResource = /** @class */ (function (_super) {
    __extends(TransactionAdjustmentsResource, _super);
    function TransactionAdjustmentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionAdjustmentsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/billing/transaction/adjustments',
            headers: params.headers,
            method: 'POST',
        });
    };
    TransactionAdjustmentsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/billing/transaction/adjustments/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TransactionAdjustmentsResource;
}($Resource));
export { TransactionAdjustmentsResource };
var TribesResource = /** @class */ (function (_super) {
    __extends(TribesResource, _super);
    function TribesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List all tribes. There is no pagination as number of tribes is small.*/
    TribesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/tribes"),
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
            },
        });
    };
    TribesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/".concat(encodeURIComponent(params.organization), "/tribes/").concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TribesResource;
}($Resource));
export { TribesResource };
var UnclassifiedProductsPurgeRequestsResource = /** @class */ (function (_super) {
    __extends(UnclassifiedProductsPurgeRequestsResource, _super);
    function UnclassifiedProductsPurgeRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Deletes products from the `unclassified_products` table for all the organizations listed into: [excluded-orgs.json](https://github.com/flowcommerce/harmonization/blob/main/core/conf/excluded-orgs.json)*/
    UnclassifiedProductsPurgeRequestsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/unclassified/products/purge/request',
            headers: params.headers,
            method: 'POST',
        });
    };
    return UnclassifiedProductsPurgeRequestsResource;
}($Resource));
export { UnclassifiedProductsPurgeRequestsResource };
var UnclassifiedProductsSummariesResource = /** @class */ (function (_super) {
    __extends(UnclassifiedProductsSummariesResource, _super);
    function UnclassifiedProductsSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnclassifiedProductsSummariesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/unclassified/products/summary',
            headers: params.headers,
            method: 'GET',
        });
    };
    return UnclassifiedProductsSummariesResource;
}($Resource));
export { UnclassifiedProductsSummariesResource };
var UserOneTimeTokensResource = /** @class */ (function (_super) {
    __extends(UserOneTimeTokensResource, _super);
    function UserOneTimeTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Create a one time token to represent the authenticated user. Token is valid for 30 seconds.*/
    UserOneTimeTokensResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/users/tokens',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Retrieves a user if the token is valid. Once called, the token is immediately invalidated and cannot be used again.*/
    UserOneTimeTokensResource.prototype.postRedeem = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/tokens/redeem',
            headers: params.headers,
            method: 'POST',
        });
    };
    return UserOneTimeTokensResource;
}($Resource));
export { UserOneTimeTokensResource };
var UserProductDetailSettingsResource = /** @class */ (function (_super) {
    __extends(UserProductDetailSettingsResource, _super);
    function UserProductDetailSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProductDetailSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/setting/product/details"),
            headers: params.headers,
            method: 'GET',
        });
    };
    UserProductDetailSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/setting/product/details"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    UserProductDetailSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/setting/product/details"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return UserProductDetailSettingsResource;
}($Resource));
export { UserProductDetailSettingsResource };
var UserProductListSettingsResource = /** @class */ (function (_super) {
    __extends(UserProductListSettingsResource, _super);
    function UserProductListSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProductListSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/settings/product/list"),
            headers: params.headers,
            method: 'GET',
        });
    };
    UserProductListSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/settings/product/list"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    UserProductListSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/courthouse/".concat(encodeURIComponent(params.organization), "/settings/product/list"),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return UserProductListSettingsResource;
}($Resource));
export { UserProductListSettingsResource };
var UserStatusRulesResource = /** @class */ (function (_super) {
    __extends(UserStatusRulesResource, _super);
    function UserStatusRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserStatusRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/user/status/rules',
            headers: params.headers,
            method: 'GET',
            query: {
                domain: params.domain,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    UserStatusRulesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/user/status/rules',
            headers: params.headers,
            method: 'POST',
        });
    };
    UserStatusRulesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/user/status/rules/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
        });
    };
    UserStatusRulesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/user/status/rules/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'PUT',
        });
    };
    UserStatusRulesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/user/status/rules/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return UserStatusRulesResource;
}($Resource));
export { UserStatusRulesResource };
var V1CheckoutsResource = /** @class */ (function (_super) {
    __extends(V1CheckoutsResource, _super);
    function V1CheckoutsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V1CheckoutsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/checkouts',
            headers: params.headers,
            method: 'POST',
        });
    };
    V1CheckoutsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/checkouts/".concat(encodeURIComponent(params.id)),
            headers: params.headers,
            method: 'GET',
            query: {
                feature_key: params.feature_key,
            },
        });
    };
    V1CheckoutsResource.prototype.putSubmissionsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/checkouts/".concat(encodeURIComponent(params.id), "/submissions"),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return V1CheckoutsResource;
}($Resource));
export { V1CheckoutsResource };
var ViesResultsResource = /** @class */ (function (_super) {
    __extends(ViesResultsResource, _super);
    function ViesResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViesResultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/tax/registration',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                name: params.name,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ViesResultsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/tax/registration/".concat(encodeURIComponent(params.number)),
            headers: params.headers,
            method: 'GET',
            query: {
                name: params.name,
            },
        });
    };
    return ViesResultsResource;
}($Resource));
export { ViesResultsResource };
var WebhooksResource = /** @class */ (function (_super) {
    __extends(WebhooksResource, _super);
    function WebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebhooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/".concat(encodeURIComponent(params.organization), "/shopify/markets/webhook"),
            headers: params.headers,
            method: 'POST',
        });
    };
    return WebhooksResource;
}($Resource));
export { WebhooksResource };
export function createClient(options) {
    return {
        accountPaymentHolds: new AccountPaymentHoldsResource(options),
        addressConfigurationSettings: new AddressConfigurationSettingsResource(options),
        aftershipWebhooks: new AftershipWebhooksResource(options),
        aldoItems: new AldoItemsResource(options),
        alertFailureSummaries: new AlertFailureSummariesResource(options),
        alertRequeueSummaries: new AlertRequeueSummariesResource(options),
        allOrganizationsMemberships: new AllOrganizationsMembershipsResource(options),
        authorizedChargeStatuses: new AuthorizedChargeStatusesResource(options),
        bankPayments: new BankPaymentsResource(options),
        bankPaymentOrders: new BankPaymentOrdersResource(options),
        bankPaymentStatusImports: new BankPaymentStatusImportsResource(options),
        billingOrganizationProcessingRates: new BillingOrganizationProcessingRatesResource(options),
        billingSandboxSetups: new BillingSandboxSetupsResource(options),
        brickWebhookEvents: new BrickWebhookEventsResource(options),
        browserBundles: new BrowserBundlesResource(options),
        calculatorOrganizationSettings: new CalculatorOrganizationSettingsResource(options),
        callRecords: new CallRecordsResource(options),
        carrierAccounts: new CarrierAccountsResource(options),
        carrierFiles: new CarrierFilesResource(options),
        catalogSettings: new CatalogSettingsResource(options),
        centerDefaults: new CenterDefaultsResource(options),
        centerQueryBuilders: new CenterQueryBuildersResource(options),
        channelAccounts: new ChannelAccountsResource(options),
        channelBilledTransactionPairs: new ChannelBilledTransactionPairsResource(options),
        channelBillingStatements: new ChannelBillingStatementsResource(options),
        channelCurrencyPairsInternal: new ChannelCurrencyPairsInternalResource(options),
        channelCurrencySettings: new ChannelCurrencySettingsResource(options),
        channelDebugTransactions: new ChannelDebugTransactionsResource(options),
        channelFulfillments: new ChannelFulfillmentsResource(options),
        channelMemberships: new ChannelMembershipsResource(options),
        channelOrders: new ChannelOrdersResource(options),
        channelOrderAcceptances: new ChannelOrderAcceptancesResource(options),
        channelOrderAcceptanceDetails: new ChannelOrderAcceptanceDetailsResource(options),
        channelOrganizationShopify: new ChannelOrganizationShopifyResource(options),
        chargebacks: new ChargebacksResource(options),
        checkoutBundles: new CheckoutBundlesResource(options),
        checkoutConfigurations: new CheckoutConfigurationsResource(options),
        checkoutContentSummaries: new CheckoutContentSummariesResource(options),
        checkoutFinalizeOrderForms: new CheckoutFinalizeOrderFormsResource(options),
        checkoutSubmitOrderBundles: new CheckoutSubmitOrderBundlesResource(options),
        ciphers: new CiphersResource(options),
        classifications: new ClassificationsResource(options),
        classificationActions: new ClassificationActionsResource(options),
        classificationDetails: new ClassificationDetailsResource(options),
        classificationProductSummaryPages: new ClassificationProductSummaryPagesResource(options),
        classificationRequeueRequests: new ClassificationRequeueRequestsResource(options),
        classificationStatistics: new ClassificationStatisticsResource(options),
        classificationTaxonomy: new ClassificationTaxonomyResource(options),
        cliLogEntries: new CliLogEntriesResource(options),
        commercialInvoiceComparisons: new CommercialInvoiceComparisonsResource(options),
        commercialInvoiceSummaries: new CommercialInvoiceSummariesResource(options),
        compliances: new CompliancesResource(options),
        consumerOptinActivities: new ConsumerOptinActivitiesResource(options),
        contentSchemas: new ContentSchemasResource(options),
        courthouseProductSummaries: new CourthouseProductSummariesResource(options),
        customerSecrets: new CustomerSecretsResource(options),
        customsDetails: new CustomsDetailsResource(options),
        debugOrders: new DebugOrdersResource(options),
        debugOrderTransactions: new DebugOrderTransactionsResource(options),
        deliveredDutyOptions: new DeliveredDutyOptionsResource(options),
        deliveredDutyPreferences: new DeliveredDutyPreferencesResource(options),
        discountCodes: new DiscountCodesResource(options),
        disputes: new DisputesResource(options),
        dutyInternalRates: new DutyInternalRatesResource(options),
        erpFlowFiles: new ErpFlowFilesResource(options),
        erpFlowVendors: new ErpFlowVendorsResource(options),
        erpPriorityFiles: new ErpPriorityFilesResource(options),
        erpPriorityVendors: new ErpPriorityVendorsResource(options),
        erpVendorStatuses: new ErpVendorStatusesResource(options),
        explicitStatements: new ExplicitStatementsResource(options),
        externalFulfillmentProofs: new ExternalFulfillmentProofsResource(options),
        features: new FeaturesResource(options),
        featureValues: new FeatureValuesResource(options),
        financeBankAccounts: new FinanceBankAccountsResource(options),
        financeBankPayments: new FinanceBankPaymentsResource(options),
        financialMerchantCategories: new FinancialMerchantCategoriesResource(options),
        financialReportingStatements: new FinancialReportingStatementsResource(options),
        flexeWebhooks: new FlexeWebhooksResource(options),
        flowAccounts: new FlowAccountsResource(options),
        flowBillingStatements: new FlowBillingStatementsResource(options),
        flowChannelOrganizations: new FlowChannelOrganizationsResource(options),
        flowLabProjects: new FlowLabProjectsResource(options),
        flowLabelSettings: new FlowLabelSettingsResource(options),
        fraudPendingReviews: new FraudPendingReviewsResource(options),
        fraudPendingReviewDetails: new FraudPendingReviewDetailsResource(options),
        fraudProviderConfigurations: new FraudProviderConfigurationsResource(options),
        fraudReviews: new FraudReviewsResource(options),
        fraudReviewDecisions: new FraudReviewDecisionsResource(options),
        ftpSettings: new FtpSettingsResource(options),
        generateLoads: new GenerateLoadsResource(options),
        giftCardPrograms: new GiftCardProgramsResource(options),
        globalSearchResults: new GlobalSearchResultsResource(options),
        googleShoppingSettings: new GoogleShoppingSettingsResource(options),
        harmonizationItemClassifications: new HarmonizationItemClassificationsResource(options),
        harmonizationThresholds: new HarmonizationThresholdsResource(options),
        harmonizationUnclassifiedStatistics: new HarmonizationUnclassifiedStatisticsResource(options),
        hs6: new Hs6Resource(options),
        internalDebugTransactions: new InternalDebugTransactionsResource(options),
        internalHarmonizationStatistics: new InternalHarmonizationStatisticsResource(options),
        internalPaymentRequests: new InternalPaymentRequestsResource(options),
        internalPaymentRequestVerifications: new InternalPaymentRequestVerificationsResource(options),
        invariants: new InvariantsResource(options),
        adyenDisputeEvents: new AdyenDisputeEventsResource(options),
        notificationRequests: new NotificationRequestsResource(options),
        invoiceWebhookResponses: new InvoiceWebhookResponsesResource(options),
        items: new ItemsResource(options),
        channels: new ChannelsResource(options),
        channelCurrencies: new ChannelCurrenciesResource(options),
        checkoutReferences: new CheckoutReferencesResource(options),
        users: new UsersResource(options),
        cryptoEvents: new CryptoEventsResource(options),
        experiences: new ExperiencesResource(options),
        orders: new OrdersResource(options),
        paypalDisputeEvents: new PaypalDisputeEventsResource(options),
        webhookEvents: new WebhookEventsResource(options),
        ultimateBeneficiaryOwners: new UltimateBeneficiaryOwnersResource(options),
        orderManagementEvents: new OrderManagementEventsResource(options),
        onboardingStates: new OnboardingStatesResource(options),
        memberships: new MembershipsResource(options),
        authorizations: new AuthorizationsResource(options),
        permissionAudits: new PermissionAuditsResource(options),
        simplePermissionChecks: new SimplePermissionChecksResource(options),
        queryBuilders: new QueryBuildersResource(options),
        ratecards: new RatecardsResource(options),
        serviceFees: new ServiceFeesResource(options),
        countries: new CountriesResource(options),
        organizationSessions: new OrganizationSessionsResource(options),
        shopifyOrders: new ShopifyOrdersResource(options),
        knowYourBusinesses: new KnowYourBusinessesResource(options),
        shopifyCarts: new ShopifyCartsResource(options),
        shopifyCartConversions: new ShopifyCartConversionsResource(options),
        shopifyLocalizedVariants: new ShopifyLocalizedVariantsResource(options),
        stripeDisputeEvents: new StripeDisputeEventsResource(options),
        stripeEvents: new StripeEventsResource(options),
        channelTokens: new ChannelTokensResource(options),
        itemClassifications: new ItemClassificationsResource(options),
        itemClassificationSummaries: new ItemClassificationSummariesResource(options),
        itemHarmonizations: new ItemHarmonizationsResource(options),
        itemRestrictions: new ItemRestrictionsResource(options),
        itemSalesMargins: new ItemSalesMarginsResource(options),
        jeanDemoItems: new JeanDemoItemsResource(options),
        keys: new KeysResource(options),
        labProjectSettings: new LabProjectSettingsResource(options),
        labelCreationJobs: new LabelCreationJobsResource(options),
        labelGenerationSettings: new LabelGenerationSettingsResource(options),
        labelRequestResults: new LabelRequestResultsResource(options),
        labelTaxonomy: new LabelTaxonomyResource(options),
        levyRateSummaries: new LevyRateSummariesResource(options),
        liabilityRemittancePlans: new LiabilityRemittancePlansResource(options),
        localizableContents: new LocalizableContentsResource(options),
        localizations: new LocalizationsResource(options),
        localizedContents: new LocalizedContentsResource(options),
        localizedItemsExportSettings: new LocalizedItemsExportSettingsResource(options),
        logisticsCapabilities: new LogisticsCapabilitiesResource(options),
        logisticsPayoutRequests: new LogisticsPayoutRequestsResource(options),
        lostChargebacks: new LostChargebacksResource(options),
        loyaltyPrograms: new LoyaltyProgramsResource(options),
        manualReviewRules: new ManualReviewRulesResource(options),
        marketingGatewayChannels: new MarketingGatewayChannelsResource(options),
        marketingGatewayChannelSourceSummaries: new MarketingGatewayChannelSourceSummariesResource(options),
        marketingGatewayFacebookBusinesses: new MarketingGatewayFacebookBusinessesResource(options),
        marketingGatewayFacebookConnections: new MarketingGatewayFacebookConnectionsResource(options),
        marketingGatewayFacebookConnectionAccessTokenSummaries: new MarketingGatewayFacebookConnectionAccessTokenSummariesResource(options),
        marketingGatewayFacebookConnectionDeauths: new MarketingGatewayFacebookConnectionDeauthsResource(options),
        marketingGatewayFeeds: new MarketingGatewayFeedsResource(options),
        marketingGatewayFeedForms: new MarketingGatewayFeedFormsResource(options),
        marketingGatewayFeedSources: new MarketingGatewayFeedSourcesResource(options),
        marketingGatewayGoogleConnections: new MarketingGatewayGoogleConnectionsResource(options),
        marketingGatewayLocalizedItems: new MarketingGatewayLocalizedItemsResource(options),
        marketsOrders: new MarketsOrdersResource(options),
        marketsOrderSummaries: new MarketsOrderSummariesResource(options),
        merchantApplicationSummaries: new MerchantApplicationSummariesResource(options),
        merchantHubOverrides: new MerchantHubOverridesResource(options),
        merchantOfRecordEntitySettings: new MerchantOfRecordEntitySettingsResource(options),
        negativeDebitMetrics: new NegativeDebitMetricsResource(options),
        onboardingAuditReports: new OnboardingAuditReportsResource(options),
        onboardingAuditSnapshots: new OnboardingAuditSnapshotsResource(options),
        onboardingOrganizations: new OnboardingOrganizationsResource(options),
        optinAttributes: new OptinAttributesResource(options),
        optinPrompts: new OptinPromptsResource(options),
        optinPromptCopies: new OptinPromptCopiesResource(options),
        orderActionabilities: new OrderActionabilitiesResource(options),
        orderAddressValidations: new OrderAddressValidationsResource(options),
        orderCancellations: new OrderCancellationsResource(options),
        orderCombinedShipments: new OrderCombinedShipmentsResource(options),
        orderDetails: new OrderDetailsResource(options),
        orderPaymentAuthorizations: new OrderPaymentAuthorizationsResource(options),
        orderRevenueRegionCharts: new OrderRevenueRegionChartsResource(options),
        orderRevenueTimelineCharts: new OrderRevenueTimelineChartsResource(options),
        organizationAccounts: new OrganizationAccountsResource(options),
        organizationBillingStatements: new OrganizationBillingStatementsResource(options),
        organizationCurrencySettings: new OrganizationCurrencySettingsResource(options),
        organizationDeactivations: new OrganizationDeactivationsResource(options),
        organizationDebugTransactions: new OrganizationDebugTransactionsResource(options),
        organizationMembershipCopies: new OrganizationMembershipCopiesResource(options),
        organizationOnboardingStateAuditResults: new OrganizationOnboardingStateAuditResultsResource(options),
        organizationPaymentSettings: new OrganizationPaymentSettingsResource(options),
        organizationRestrictionStatuses: new OrganizationRestrictionStatusesResource(options),
        organizationRestrictionStatusNotes: new OrganizationRestrictionStatusNotesResource(options),
        organizationSettings: new OrganizationSettingsResource(options),
        organizationsAuditCheckReports: new OrganizationsAuditCheckReportsResource(options),
        partners: new PartnersResource(options),
        partnerAuthorizations: new PartnerAuthorizationsResource(options),
        partnerMemberships: new PartnerMembershipsResource(options),
        partnerOrganizationAuthorizations: new PartnerOrganizationAuthorizationsResource(options),
        partnerOrganizationSettings: new PartnerOrganizationSettingsResource(options),
        passphrases: new PassphrasesResource(options),
        paymentMethodDetails: new PaymentMethodDetailsResource(options),
        paymentOrganizationSettings: new PaymentOrganizationSettingsResource(options),
        paymentRedirects: new PaymentRedirectsResource(options),
        pendingBankPayments: new PendingBankPaymentsResource(options),
        platformFeeChanges: new PlatformFeeChangesResource(options),
        processorAccounts: new ProcessorAccountsResource(options),
        processorMerchants: new ProcessorMerchantsResource(options),
        productClassifications: new ProductClassificationsResource(options),
        productReviewHistories: new ProductReviewHistoriesResource(options),
        pspRoutingDistributionRevisions: new PspRoutingDistributionRevisionsResource(options),
        publicHubs: new PublicHubsResource(options),
        rateAndRuleLookups: new RateAndRuleLookupsResource(options),
        rateLevels: new RateLevelsResource(options),
        rateLevelOrganizations: new RateLevelOrganizationsResource(options),
        rateLevelRatecards: new RateLevelRatecardsResource(options),
        ratecardServiceFeesOverrides: new RatecardServiceFeesOverridesResource(options),
        ratecardStandardConfigurations: new RatecardStandardConfigurationsResource(options),
        ratesNamesSummaries: new RatesNamesSummariesResource(options),
        reboundConfigurations: new ReboundConfigurationsResource(options),
        reports: new ReportsResource(options),
        reportSummary: new ReportSummaryResource(options),
        rescreenRestrictionsProducts: new RescreenRestrictionsProductsResource(options),
        restrictionCategories: new RestrictionCategoriesResource(options),
        restrictionFilters: new RestrictionFiltersResource(options),
        restrictionItems: new RestrictionItemsResource(options),
        restrictionOrganizations: new RestrictionOrganizationsResource(options),
        restrictionOrganizationDecisionSummaries: new RestrictionOrganizationDecisionSummariesResource(options),
        restrictionProducts: new RestrictionProductsResource(options),
        restrictionProductSummaries: new RestrictionProductSummariesResource(options),
        restrictionRules: new RestrictionRulesResource(options),
        restrictionRuleOverrides: new RestrictionRuleOverridesResource(options),
        routingEntities: new RoutingEntitiesResource(options),
        sandboxSetups: new SandboxSetupsResource(options),
        screens: new ScreensResource(options),
        searchProviderExports: new SearchProviderExportsResource(options),
        sessionCountries: new SessionCountriesResource(options),
        sessionOrderData: new SessionOrderDataResource(options),
        sessionRollouts: new SessionRolloutsResource(options),
        shippingLanes: new ShippingLanesResource(options),
        shops: new ShopsResource(options),
        shopifyGiftCardBalances: new ShopifyGiftCardBalancesResource(options),
        shopifyGiftCardRedemptions: new ShopifyGiftCardRedemptionsResource(options),
        shopifyGiftCardReversals: new ShopifyGiftCardReversalsResource(options),
        shopifyGrantsChecks: new ShopifyGrantsChecksResource(options),
        shopifyMarketsOrderVersionWithShopIds: new ShopifyMarketsOrderVersionWithShopIdsResource(options),
        shopifyMarketsQueuedRecords: new ShopifyMarketsQueuedRecordsResource(options),
        shopifyMarketsShops: new ShopifyMarketsShopsResource(options),
        shopifyMarketsShopSummaries: new ShopifyMarketsShopSummariesResource(options),
        shopifyMarketsSyncs: new ShopifyMarketsSyncsResource(options),
        shopifyMarketsWebhookRegistrations: new ShopifyMarketsWebhookRegistrationsResource(options),
        shopifyMonitoringOrderMonitors: new ShopifyMonitoringOrderMonitorsResource(options),
        shopifyMonitoringOrderMonitorReviews: new ShopifyMonitoringOrderMonitorReviewsResource(options),
        shopifyOrderDetails: new ShopifyOrderDetailsResource(options),
        shopifyOrderFulfillmentsSnapshots: new ShopifyOrderFulfillmentsSnapshotsResource(options),
        shopifyOrganizationSettings: new ShopifyOrganizationSettingsResource(options),
        shopifyPartnerWebhooks: new ShopifyPartnerWebhooksResource(options),
        shopifyPromotions: new ShopifyPromotionsResource(options),
        shopifyStoreDetails: new ShopifyStoreDetailsResource(options),
        shopifyWebhookEvents: new ShopifyWebhookEventsResource(options),
        smpTaxCalculationForms: new SmpTaxCalculationFormsResource(options),
        snoozes: new SnoozesResource(options),
        spotRates: new SpotRatesResource(options),
        storeConnections: new StoreConnectionsResource(options),
        tariffEligibilities: new TariffEligibilitiesResource(options),
        tasks: new TasksResource(options),
        taxCalculationForms: new TaxCalculationFormsResource(options),
        techOnboardingDescriptions: new TechOnboardingDescriptionsResource(options),
        tests: new TestsResource(options),
        trackingDebugLabels: new TrackingDebugLabelsResource(options),
        trackingResyncs: new TrackingResyncsResource(options),
        trackingWebhooks: new TrackingWebhooksResource(options),
        transactions: new TransactionsResource(options),
        transactionAdjustments: new TransactionAdjustmentsResource(options),
        tribes: new TribesResource(options),
        unclassifiedProductsPurgeRequests: new UnclassifiedProductsPurgeRequestsResource(options),
        unclassifiedProductsSummaries: new UnclassifiedProductsSummariesResource(options),
        userOneTimeTokens: new UserOneTimeTokensResource(options),
        userProductDetailSettings: new UserProductDetailSettingsResource(options),
        userProductListSettings: new UserProductListSettingsResource(options),
        userStatusRules: new UserStatusRulesResource(options),
        v1Checkouts: new V1CheckoutsResource(options),
        viesResults: new ViesResultsResource(options),
        webhooks: new WebhooksResource(options),
    };
}
